// ADL
import $ from 'jquery';
import 'jquery-ui/dist/jquery-ui'; 
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/js/dist/modal'; 
import frm from '../formAux.js'
const { Liquid } = require('liquidjs');
// const macros = require('./macros.js'); ---jest test only---
// const { processAndParseTranscript, generateExportString } = require('./transcriptProcessor.js'); ---jest test only---
var mode = 'adl';
var transcriptionData = [];
var selectedLineForAlignmentIndex = null;
var currentlyHighlightedLineIndex = null;
var needsUiRefresh = false;
var currentlyHighlightedWord = { line: -1, word: -1 };
var currentlyHighlightedWord = { line: -1, word: -1 };
var currentlyEditingRow = { index: null };
var transcriptNeedsAlignment = false;
const LOCAL_STORAGE_KEY = 'transcriptDraft';
var closeIcon = '';
var searchIcon = '';
var descriptor = {};
var tagData = descriptor;
var dashjs = window.dashjs;
var WaveSurfer = window.WaveSurver;
var hinst = null;
var jQuery = $;
var modeSelDrop = null;
var wsclicked = false;
var seekPlaying = null;
var tempVisibleRegion = null;
var originalEyeState = null;
var video = $('#video')[0];
var audioObj = $('#audio')[0];
var txtSeparator = ': ';
var wavesurfer = null;
var playToCallback = null;
var declined = false;
var claimed = false;
var released = false;
var reviewMode = false;
var transcriptionMode = false;

let videoClick = false;
let videoClickTid = null;

var currentMode = null;
var currentSeg = null;
var waveMode = null;
var declineReason = '';

var allowOverlap = true;

function px(v) { return v+'px'; }
function pc(v) { if( v < 0 ) v = 0; if( v > 100 ) v = 100; return Math.round(v)+'%'; }
function val(v) { v = parseFloat(v); if( isNaN(v) ) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isarray( o ){ return o instanceof Array;}
function isobj( o ){ return !isarray(o) && o instanceof Object;}
function isnumber( o ){ return typeof(o) == 'number' && !isNaN(o);}
function isstring( o ){ return typeof(o) == 'string';}
function defined( o ){ return typeof(o) != 'undefined';}
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec(){	return new Date().getTime(); }
function getsec(){ return Math.round(getmsec()/1000); }
function nullFunc() { return null; }
function cancelEvent(ev) { if( !ev )return false; ev.preventDefault(); ev.stopPropagation();}

function iarray( v, n )
{
	var ret = [];
	for( var i = 0 ; i < n ; i++ )
	ret.push( v instanceof Object ? clone(v) : v );
	return ret;
}

function bool( s )
{
	if( typeof(s) == 'boolean' ) return s;
	if( !defined(s) || s === null ) return false;
	if( typeof(s) == 'number' ) return s > 0;
	if( s.match(/^y/i) ) return true;
	return false;
}

function sbool( v )
{
	return ['No','Yes'][v];
}

var setHeightTid = null;

// function paletteWheel( div, brightness )
// {
// 	if( !brightness ) brightness = 1;
//   	var steps = [[255,0,0],[0,255,0],[0,0,255],[255,0,0]];
//     var colors = [];
//     function interpolate(v)
//     {
//         v *= steps.length-1;
//         var i = Math.floor(v);
//         var r = v-i;
//         var ir = 1-r;
//         // console.log( 'v', v, 'i', i, 'r', r );
//         return [steps[i][0]*ir+steps[i+1][0]*r,steps[i][1]*ir+steps[i+1][1]*r,steps[i][2]*ir+steps[i+1][2]*r];
//     }
//     for( var d = 0 ; d < div ; d++ )
//     {
//         var c = interpolate( d/div);
//         var hc = '#' + c.map( v => Math.min(Math.floor(v*brightness),255).toString(16).padStart(2,'0')).join('');
//         colors.push( hc );
//     }
//     return colors;
// }
// DELETE the entire old stringToColor function.
// REPLACE it with this new, more accurate version.

/**
 * Generates a consistent, visually pleasing and highly distinct color from a string.
 * This version uses the golden angle for hue distribution and hash-based ranges
 * for saturation and lightness to maximize perceptual distance between colors.
 * @param {string} str The tag name to convert into a color.
 * @returns {string} A hex color code (e.g., "#RRGGBB").
 */

function stringToColor(str) {
    if (!str) {
        return '#808080'; 
    }

    const PREDEFINED_PALETTE = [
        '#e6194b', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#911eb4', '#46f0f0', '#f032e6',
        '#bcf60c', '#fabebe', '#008080', '#e6beff', '#9a6324', '#fffac8', '#800000', '#aaffc3',
        '#808000', '#ffd8b1', '#000075', '#808080', '#ffc107', '#28a745', '#17a2b8', '#6f42c1',
        '#fd7e14', '#20c997', '#d63384', '#6610f2', '#dc3545', '#0dcaf0'
    ];

    // 1. Generate a simple, fast hash from the string.
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash; // Convert to 32bit integer
    }

    // 2. Use the hash to pick a color from the palette.
    const index = Math.abs(hash) % PREDEFINED_PALETTE.length;
    return PREDEFINED_PALETTE[index];
}
function showLockAlert() {
    if (!descriptor) return; 

    let lockTxt = "You don't own this task on its current state. Therefore annotations can't be created or modified.";
    if (descriptor.task_can_claim) {
      lockTxt += `<br><br>You may <b>claim</b> the task and become the task owner as <b>${descriptor.task_role}</b>`;
    }
    
    // Uses myAlert, which is defined later in the file but will be available at runtime.
    myAlert('<i class="fa fa-lock alert-icon"></i> Task Locked', lockTxt, 'Ok');
};
function tracks( domObj, videoObj, videoSource, tagData, reportObj ) {
	$('.main').show();
    window.reportObj = reportObj; // Make reportObj globally accessible
    const metadata = {
        ...(tagData.metadata || {}),
        ...(tagData.media ? tagData.media.metadata : {})
    };

    // Check if there is any metadata to display.
    if (Object.keys(metadata).length > 0) {
        // Find the main container to ensure we don't add duplicate metadata bars.
        const parentContainer = domObj.parent();
        parentContainer.find('.media-metadata-display').remove();

        // Create the new element for the metadata.
        const metadataDiv = $('<div class="media-metadata-display"></div>');

        // Build the HTML string from the metadata object (e.g., "File: ... TaskId: ...").
        const metadataHtml = Object.entries(metadata)
            .map(([key, value]) => `<span><b>${key}:</b> ${value}</span>`)
            .join('&nbsp;&nbsp;&nbsp;&nbsp;'); // Add more space for clarity

        // Apply styling and add the content.
        metadataDiv.html(metadataHtml).css({
            'padding': '10px 15px',
            'font-size': '0.9rem',
            'font-family': 'sans-serif',
            'color': '#5e5873',
            'border-bottom': '1px solid #e8e8e8',
        });

        // Prepend the metadata bar before the WaveSurfer container itself.
        domObj.before(metadataDiv);
    }
        setTimeout(function() {

    var mediaType = null, waveReady = false, waveHeight = 100, waveZoom = 8;
    let isSeeking = false; // Critical flag to know when the user is dragging the seek bar.
    video = videoObj[0];

    function setHeight() {
        if (!reportObj || !reportObj.length) return;
        const $rightContainer = $('#t_right');
        if (!$rightContainer.length) return;
        const windowHeight = $(window).height();
        const toolbarHeight = $('.video-toolbar').length ? $('.video-toolbar').outerHeight() : 50;
        const mainContainerHeight = windowHeight - toolbarHeight;
        $rightContainer.css('height', mainContainerHeight + 'px');
        const reportPanelPos = reportObj.position();
        if (!reportPanelPos) return;
        const availableReportHeight = mainContainerHeight - reportPanelPos.top - 232;
        reportObj.css({ 'height': Math.max(availableReportHeight, 200) + 'px', 'overflow-y': 'auto' });
    }
    
    function formatTimeCallback(seconds) {
        seconds = isNaN(seconds) || seconds < 0 ? 0 : seconds;
        const date = new Date(seconds * 1000);
        const minutes = date.getUTCMinutes();
        const secs = date.getUTCSeconds().toString().padStart(2, '0');
        if (date.getUTCHours() > 0) {
            return `${date.getUTCHours()}:${minutes.toString().padStart(2, '0')}:${secs}`;
        }
        return `${minutes}:${secs}`;
    }

// REPLACE THE FUNCTION AROUND LINE 1612 WITH THIS
function waveReport() {
    var reportObj = window.reportObj;
    if (!reportObj) { return; }
    reportObj.html('');
    if (!descriptor.transcript || descriptor.transcript.length === 0) {
        return reportObj.html('<span class="tag-panel-empty">(No transcript loaded)</span>');
    }

    var tab = $('<TABLE>').addClass('reporttable table table-sm table-hover');
    var thead = $('<THEAD>').append('<tr><th style="width: 121px;">Speaker</th><th>Spoken Words</th></tr>');
    tab.append(thead);
    var tbody = $('<TBODY>').prop('id', 'transcript-tbody');

    descriptor.transcript.forEach(function(line, lineIndex) {
        var tr_row = $('<TR>')
            .prop('id', `transcript-row-${line.id}`)
            .attr('data-original-index', lineIndex); 

        var speakerCell = $('<TD>').addClass('speaker-cell');
        var wrapper = $('<div>').addClass('speaker-content-wrapper');
        var dragHandle = $('<i>').addClass('fa fa-grip drag-handle').attr('title', 'Drag to reorder');
        var speakerText = $('<span>').addClass('speaker-name').text(line.speaker);
        wrapper.append(dragHandle, speakerText);
        speakerCell.append(wrapper);

        var dialogueCell = $('<TD>').addClass('dialogue-cell');
        
        var hoverActionsContainer = $('<div>').addClass('row-actions-container');

        var addAfterBtn = $('<i>')
            .addClass('fa fa-plus add-row-after-btn')
            .attr('title', 'Add row after this')
            .data('line-index', lineIndex);

        var deleteBtn = $('<i>')
            .addClass('fa fa-minus delete-row-btn')
            .attr('title', 'Delete this row')
            .data('line-index', lineIndex);

        hoverActionsContainer.append(addAfterBtn, deleteBtn);

        const dialogueContainer = $('<div class="dialogue-text-container"></div>');
        if (line.words && line.words.length > 0 && line.words[0].start != null) {
            line.words.forEach((word) => {
                dialogueContainer.append($('<span>').addClass('transcript-word').attr({ 'data-start': word.start, 'data-end': word.end }).text(word.text + ' '));
            });
        } else {
            dialogueContainer.text(line.dialogue);
        }
        dialogueCell.append(dialogueContainer, hoverActionsContainer);

        tr_row.append(speakerCell, dialogueCell);
        tbody.append(tr_row);
    });

    tab.append(tbody);
    reportObj.append(tab); 

    if ($.fn.sortable) {
        tbody.sortable({
            handle: '.drag-handle', axis: 'y',
            update: function() {
                const newOrder = [];
                $('#transcript-tbody tr').each(function() {
                    const originalIndex = $(this).data('original-index');
                    newOrder.push(descriptor.transcript[originalIndex]);
                });
                descriptor.transcript = newOrder;
                waveReport();
                changed();
            }
        })
        // .disableSelection();
    }
    window.waveReport = waveReport;
}

    function waveZoomUpdate() { if (wavesurfer) wavesurfer.zoom(waveZoom * 10); $('.wave-zoom-txt').html(Math.round(waveZoom) + 'X'); }
function waveZoomIn() {
    // --- THIS IS THE FIX ---
    // Add a check to ensure the zoom level does not go above 16.
    if (waveZoom >= 16) {
        waveZoom = 16; // Ensure it's capped exactly at 16
    } else {
        waveZoom *= 2; // Double the zoom if it's below the cap
    }
    waveZoomUpdate();
}    function waveZoomOut() { waveZoom /= 2; if (waveZoom < 1) waveZoom = 1; waveZoomUpdate(); }
    function waveRate(r) { if (wavesurfer) { wavesurfer.setPlaybackRate(r); video.playbackRate = r; $('.wave-rate').removeClass('wave-rate-selected'); $(`.v${r.toString().replace('.', '')}`).addClass('wave-rate-selected'); } }
    function wavePanel() {
        $('.wavepanel, .player-seek-container').remove(); // Clear all old controls

        // Create the new seek bar container matching your image ("0:00 / 0:01 [slider]")
        const seekContainer = $('<div>').addClass('player-seek-container');
        const timeDisplay = $('<span>').addClass('player-time-display').text('0:00 / 0:00');
        const seekBar = $('<input type="range" min="0" max="1000" value="0" class="player-seek-bar">');
        seekContainer.append(timeDisplay, seekBar);

        // Create the main controls container
        const wp = $('<DIV>').addClass('wavepanel');
        const speedControls = $('<div>').addClass('control-group speed-controls');
        speedControls.append($('<span>Speed:</span>'));
        const speedButtons = $('<div>').addClass('control-sub-group'); // New wrapper for buttons
        [0.25, 0.5, 1, 2, 4, 8].forEach(rate => {
            const speedBtn = $('<div>').addClass(`wave-rate v${rate.toString().replace('.', '')} unselectable`).html(`${rate}X`);
            speedBtn.on('click', () => {
                if (window.descriptor.blockEdit) return showLockAlert();
                waveRate(rate);
            });
            speedButtons.append(speedBtn);
        });        
        speedControls.append(speedButtons);
        // --- MODIFICATION END: SPEED CONTROLS ---

        const playerControls = $('<div>').addClass('control-group player-controls');
        playerControls.append($('<button>').addClass('player-btn').attr('title', 'Jump to Start').html('<i class="fa fa-fast-backward"></i>').on('click', () => {
            if (window.descriptor.blockEdit) return showLockAlert();
            wavesurfer && wavesurfer.setCurrentTime(0);
        }));
        playerControls.append($('<button>').addClass('player-btn').attr('title', 'Backward 5s').html('<i class="fa fa-backward"></i>').on('click', () => {
            if (window.descriptor.blockEdit) return showLockAlert();
            wavesurfer && wavesurfer.skipBackward(5);
        }));
        playerControls.append($('<button>').addClass('player-btn play-pause-btn').attr('id', 'play-pause-btn').attr('title', 'Play/Pause').html('<i class="fa fa-play-circle"></i>').on('click', () => {
            if (window.descriptor.blockEdit) return showLockAlert();
            wavesurfer && wavesurfer.playPause();
        }));
        playerControls.append($('<button>').addClass('player-btn').attr('title', 'Forward 5s').html('<i class="fa fa-forward"></i>').on('click', () => {
            if (window.descriptor.blockEdit) return showLockAlert();
            wavesurfer && wavesurfer.skipForward(5);
        }));
        playerControls.append($('<button>').addClass('player-btn').attr('title', 'Jump to End').html('<i class="fa fa-fast-forward"></i>').on('click', () => {
            if (window.descriptor.blockEdit) return showLockAlert();
            if (!wavesurfer) return;
            wavesurfer.seekTo(1); 
            const scrollableWave = $('#waveform > div')[0];
            if (scrollableWave) {
                scrollableWave.scrollLeft = scrollableWave.scrollWidth;
            }
        }));

        // --- MODIFICATION START: ZOOM CONTROLS ---
        // Group the label and its interactive buttons
        const zoomControls = $('<div>').addClass('control-group zoom-controls');
        zoomControls.append($('<span ">Track zoom: </span>'));
        const zoomButtons = $('<div>').addClass('control-sub-group'); // New wrapper for buttons
        zoomButtons.append($('<div>').addClass('wave-zoom-out unselectable').html('<i class="fa fa-minus"></i>').on('click', function() {
            if (window.descriptor.blockEdit) return showLockAlert();
            waveZoomOut();
        }));
        zoomButtons.append($('<div>').addClass('wave-zoom-txt unselectable').html(waveZoom + 'X'));
        zoomButtons.append($('<div>').addClass('wave-zoom-in unselectable').html('<i class="fa fa-plus"></i>').on('click', function() {
            if (window.descriptor.blockEdit) return showLockAlert();
            waveZoomIn();
        }));
        zoomControls.append(zoomButtons);
        // --- MODIFICATION END: ZOOM CONTROLS ---
        
        wp.append(speedControls, playerControls, zoomControls);
        $('.waveinterface').append(seekContainer, wp);
        waveRate(1);
    }

    // --- 3. CREATE WAVESURFER AND DOM STRUCTURE ---
    domObj.empty();
    domObj.append($('<div>').prop('id', 'waveformindex'), $('<div>').prop('id', 'waveform'), $('<div>').addClass('waveinterface'));

    if (tagData.audioSource) {
        $('#video').hide();
        video = $('#audio')[0];
        $(video).show().prop('controls', true);
        mediaType = 'audio';
        waveHeight = 300;
    } else {
        $('#audio').hide();
        video = $('#video')[0];
        $(video).show().prop('controls', true);
        mediaType = 'video';
        waveHeight = 100;
    }

    wavesurfer = window.WaveSurfer.create({
        container: '#waveform', waveColor: '#7367f0', progressColor: '#777777', backgroundColor: '#fff',
        height: waveHeight, backend: 'MediaElement', scrollParent: true, autoCenter: true, normalize: true,
        responsive: true,
        plugins: [
            window.WaveSurfer.minimap.create({ height: 40, waveColor: '#333', progressColor: '#999' }),
            window.WaveSurfer.timeline.create({ container: '#waveformindex', formatTimeCallback: formatTimeCallback, timeInterval: 1, primaryLabelInterval: 5, secondaryLabelInterval: 1 }),
            window.WaveSurfer.regions.create({ dragSelection: false, allowOverlap: allowOverlap })
        ]
    });
    window.wavesurfer = wavesurfer;

$('head').append($('<style>').prop('id', 'player-styles').text(`
    .player-seek-container { display: flex; align-items: center; width: 100%; padding: 8px 15px; box-sizing: border-box; gap: 15px; background: #f8f8f8; border-top: 1px solid #e8e8e8; }
    .player-time-display { font-family: monospace; font-size: 0.9em; color: #5e5873; min-width: 100px; }
    
    /* --- HIGH-FIDELITY PROGRESS BAR STYLES --- */
    /* --- HIGH-FIDELITY PROGRESS BAR STYLES (v2 - REALISTIC) --- */
.player-seek-bar {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    height: 8px; /* Slightly thicker for a more substantial feel */
    background: #e9ecef; /* The background is now the unfilled portion */
    outline: none;
    border-radius: 4px;
    cursor: pointer;
    /* This container holds the progress fill */
    background-image: linear-gradient(#7367f0, #7367f0);
    background-size: var(--progress-percent, 0%) 100%;
    background-repeat: no-repeat;
}

/* --- ADD THIS NEW CSS RULE --- */
.player-seek-bar:disabled {
    cursor: not-allowed;
    opacity: 0.7;
}
    .player-seek-bar.task-locked {
    cursor: not-allowed;
    opacity: 0.7;
}

/* Make the thumb also indicate it's not draggable */
.player-seek-bar.task-locked::-webkit-slider-thumb {
    cursor: not-allowed;
}

.player-seek-bar.task-locked::-moz-range-thumb {
    cursor: not-allowed;
}

.player-seek-bar::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 20px; /* Larger, more tactile thumb */
    height: 20px;
    background: #7367f0; /* Solid color - THIS IS THE KEY FIX */
    border-radius: 50%;
    border: 3px solid #fff; /* A white border helps it stand out */
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.25); /* Softer, more realistic shadow */
    margin-top: -6px; /* PERFECTLY CENTERED: (8px track - 20px thumb) / 2 = -6px */
    cursor: grab;
    transition: transform 0.2s ease;
}

.player-seek-bar:active::-webkit-slider-thumb {
    transform: scale(1.1); /* Subtle grow effect on drag */
    cursor: grabbing;
}

.player-seek-bar::-moz-range-thumb {
    width: 20px;
    height: 20px;
    background: #7367f0;
    border-radius: 50%;
    border: 3px solid #fff;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
    cursor: grab;
}
    /* --- END OF STYLES --- */

        .wavepanel { display: flex; justify-content: space-between; align-items: center; width: 100%; padding: 8px 15px; box-sizing: border-box; flex-wrap: wrap; border-top: 1px solid #e8e8e8;}
    
    /* MODIFIED: Added a gap between the label and its button group */
    .control-group { 
        display: flex; 
        align-items: center; 
        gap: 8px; 
    }
    
    /* NEW: This styles the new wrappers for the buttons */
    .control-sub-group {
        display: flex;
        align-items: center;
    }

    .player-controls { 
        flex-grow: 1; 
        display: flex; 
        justify-content: center; 
    }
    .player-btn { background: none; border: none; color: #5e5873; font-size: 1.3rem; cursor: pointer; transition: all 0.2s ease; padding: 5px; }
    .player-btn:hover { color: #7367f0; } .player-btn:active { transform: scale(0.9); }
    .play-pause-btn { font-size: 2.5rem; }
`));
    
function highlightWordAtTime(currentTime) {
    let activeWordLocation = { line: -1, word: -1 };
    if (!descriptor.transcript) return;

    // Find the word where currentTime is between its start and end.
    for (let i = 0; i < descriptor.transcript.length; i++) {
        const line = descriptor.transcript[i];
        if (line.words) {
            for (let j = 0; j < line.words.length; j++) {
                const word = line.words[j];
                // This check will now succeed because 'word.start' and 'word.end' are populated!
                if (word.start !== null && currentTime >= word.start && currentTime <= word.end) {
                    activeWordLocation = { line: i, word: j };
                    break;
                }
            }
        }
        if (activeWordLocation.line !== -1) break;
    }

    // Update the UI only if the highlighted word has changed.
    if (activeWordLocation.line !== currentlyHighlightedWord.line || activeWordLocation.word !== currentlyHighlightedWord.word) {
        // Remove highlight from the old word
        if (currentlyHighlightedWord.line !== -1) {
            $(`span[data-line-index=${currentlyHighlightedWord.line}][data-word-index=${currentlyHighlightedWord.word}]`).removeClass('highlighted-word');
        }
        // Add highlight to the new word
        if (activeWordLocation.line !== -1) {
            const $newWord = $(`span[data-line-index=${activeWordLocation.line}][data-word-index=${activeWordLocation.word}]`);
            $newWord.addClass('highlighted-word');

            // Auto-scroll the panel to keep the highlighted word in view
            const $reportPanel = $('#reportpanel');
            if ($newWord.length && $reportPanel.length) {
                const wordTop = $newWord.position().top;
                const panelHeight = $reportPanel.height();
                const currentScrollTop = $reportPanel.scrollTop();
                if (wordTop < 0 || wordTop > panelHeight) { // Scroll if word is out of view
                    $reportPanel.stop().animate({ scrollTop: currentScrollTop + wordTop - (panelHeight / 2) }, 200);
                }
            }
        }
        currentlyHighlightedWord = activeWordLocation;
    }
}

function updatePlayerUI() {
    if (!wavesurfer || !waveReady) return;

    const currentTime = wavesurfer.getCurrentTime();
    const duration = wavesurfer.getDuration();
    const $seekBar = $('.player-seek-bar');

    $('.player-time-display').text(`${formatTimeCallback(currentTime)} / ${formatTimeCallback(duration)}`);
    
    // THE CONDITION IS NOW SIMPLIFIED
    if (duration > 0) {
        const progressValue = (currentTime / duration) * 1000;
        $seekBar.val(progressValue);
        const percent = (progressValue / 1000) * 100;
        $seekBar.css('--progress-percent', `${percent}%`);
    }
    
    highlightWordAtTime(currentTime);
}
    
    wavesurfer.on('ready', () => {
        waveReady = true;
        populateMetadataHeader();
        if (descriptor.streams && descriptor.streams.transcript) descriptor.transcript = descriptor.streams.transcript;
        waveReport();
        frm.loadingOut();
        wavePanel();
        waveZoomUpdate();
        updatePlayerUI();
        setHeight();
        $(window).on('resize', setHeight);
    });

    wavesurfer.on('audioprocess', updatePlayerUI); // Syncs UI during playback.
    wavesurfer.on('seek', (progress) => {
        updatePlayerUI();

        const scrollableWave = $('#waveform > wave')[0]; // The scrollable element
        if (scrollableWave) {
            const totalWidth = scrollableWave.scrollWidth;
            const viewportWidth = scrollableWave.clientWidth;

            // 1. Calculate the target pixel position based on progress (0.0 to 1.0)
            const targetPixel = totalWidth * progress;

            // 2. Calculate the ideal scroll position to center the target pixel
            let newScrollLeft = targetPixel - (viewportWidth / 2);

            // 3. Clamp the value to prevent scrolling past the boundaries
            const maxScroll = totalWidth - viewportWidth;
            newScrollLeft = Math.max(0, newScrollLeft);       // Don't scroll left of the start
            newScrollLeft = Math.min(maxScroll, newScrollLeft); // Don't scroll right of the end

            // 4. Apply the final, corrected scroll position
            scrollableWave.scrollLeft = newScrollLeft;
        }
        // --- END OF DEFINITIVE SCROLLING FIX ---
    });  
// NEW,CORRECTED CODE
wavesurfer.on('click', (progress) => {
    wavesurfer.setCurrentTime(progress * wavesurfer.getDuration());
});
    wavesurfer.on('play', () => $('#play-pause-btn i').removeClass('fa-play-circle').addClass('fa-pause-circle'));
    wavesurfer.on('pause', () => $('#play-pause-btn i').removeClass('fa-pause-circle').addClass('fa-play-circle'));
// This is the new, corrected code
wavesurfer.on('finish', () => { 
    $(' #play-pause-btn i').removeClass('fa-pause-circle').addClass('fa-play-circle'); 
    $('.player-seek-bar').val(1000); 

    // THIS IS THE FIX: Also scroll the view to the end when playback finishes.
    const scrollableWave = $('#waveform > div')[0];
    if (scrollableWave) {
        scrollableWave.scrollLeft = scrollableWave.scrollWidth;
    }
});
    wavesurfer.on('error', (err) => console.error('WaveSurfer error:', err));
    
    // NEW, CORRECTED CODE
$('.waveinterface').on('input', '.player-seek-bar', function() {
        if (window.descriptor.blockEdit) return;
    const $this = $(this);
    const progressValue = $this.val();
    
    const percent = (progressValue / 1000) * 100;
    $this.css('--progress-percent', `${percent}%`);

    const progress = progressValue / 1000;
    wavesurfer.setCurrentTime(progress * wavesurfer.getDuration()); // Use setCurrentTime
});

$('.waveinterface').on('mousedown touchstart', '.player-seek-bar', function(e) {
    // --- THIS IS THE DEFINITIVE FIX ---
    // Check if the task is locked
    if (window.descriptor.blockEdit) {
        // 1. Immediately prevent the browser's default drag behavior. This is crucial.
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        // 2. Show the "Task Locked" alert to the user.
        showLockAlert();

        // 3. Return false to be absolutely sure no other listeners fire.
        return false;
    }

    // If the task is not locked, proceed as normal.
    isSeeking = true;
});    
$(document).on('mouseup touchend', () => { isSeeking = false; }); // Listen on document to catch mouseup anywhere

    // Handle clicks on transcribed words
    $(document).on('click', '.transcript-word', function() {
        const start = parseFloat($(this).data('start'));
        if (!isNaN(start)) wavesurfer.setCurrentTime(start);
    });
    
// Handle keyboard shortcuts for Play/Pause, Seeking, AND Deleting Rows
$(document.body).off('keydown').on('keydown', function(e) {
    // Ignore shortcuts if the user is typing in an input/textarea field
if ($(e.target).is('input, textarea')) return;

    const isPlaybackKey = [32, 37, 39, 38, 40].includes(e.keyCode);
    if (isPlaybackKey && window.descriptor.blockEdit) {
        e.preventDefault();
        return showLockAlert();
    }
    switch (e.keyCode) {
        // --- Playback Controls ---
        case 32: // Spacebar
            e.preventDefault();
            wavesurfer.playPause();
            break;
        case 37: // Left Arrow
            e.preventDefault();
            wavesurfer.skipBackward(1);
            break;
        case 39: // Right Arrow
            e.preventDefault();
            wavesurfer.skipForward(1);
            break;
        case 38: // Up Arrow
            e.preventDefault();
            wavesurfer.skipForward(10);
            break;
        case 40: // Down Arrow
            e.preventDefault();
            wavesurfer.skipBackward(10);
            break;

        // --- NEW: Row Deletion Logic ---
        case 46: // Delete key
        case 8:  // Backspace key
            const $selectedRow = $('#transcript-tbody tr.selected-row');
            
            // If a row is selected, trigger deletion
            if ($selectedRow.length > 0) {
                e.preventDefault(); // Prevent default browser actions
                const originalIndex = $selectedRow.data('original-index');

                myAlert(
                    'Confirm Deletion',
                    'Are you sure you want to delete the selected dialogue row?',
                    '^Delete Row',
                    function() {
                        if (typeof originalIndex !== 'undefined') {
                            descriptor.transcript.splice(originalIndex, 1);
                        }
                        myAlertClose(function() {
                            // This will now work because it's in the correct scope
                            waveReport(); 
                            changed();
                        });
                    },
                    'Cancel',
                    function() { myAlertClose(); }
                );
            }
            break; // End of delete case
    }
});

    // --- 7. LOAD MEDIA ---
    video.src = tagData.audioSource || tagData.videoSource;
    wavesurfer.load(video);

    return this;
    }, 0); 
}

function showVersion(s)
{
	descriptor.version = s;
	$('#version').remove();
	$('#t_right').prepend(
		$('<span>')
		.addClass('version')
		.prop('id','version')
		.html('Version: '+s)
	);
}

function checkBox( div, label, checked, callback )
{
	function ck( bool, label )
	{
		var rck = bool ? 'fa-check-square-o' : 'fa-square-o';
		return '<i class="fa ' + rck + ' check-box-icon"></i> ' + label;
	}
	var cbox = $('<div>').prop('field', 'check-'+label ).addClass('radio-list').addClass('field');
	cbox.html('<div class="err"></div>');

	var sopt = $('<span>').addClass('radio-list-option').html( ck( checked, label) ).prop('checked',checked).on('click', function(){
		var checked = $(this).prop('checked') || false;
		checked = !checked;
		$(this).prop('checked', checked)
		$(this).html(ck( checked, label));
		if( callback ) callback(checked);
	})
	cbox.append( sopt );
	div.html('').append(cbox)
	console.log( 'checkbox', label, checked );
}


function radioList( div, iattrs, opt )
{
	var radio = $('<div>').prop('field', 'radio-'+iattrs.label ).addClass('radio-list').addClass('field');
	console.log( 'radioList', iattrs, opt );
	function ck( bool )
	{
		var rck = bool ? 'fa-check-circle-o' : 'fa-circle-o';
		return '<i class="fa ' + rck + '"></i>';
	}
	if( !opt ) opt = {};
	var optid = iattrs.label;
	function options()
	{
		radio.html('<div class="err"></div>');
		if( !iattrs.noLabel ) radio.append('<span class="radio-list-title">' + iattrs.label + ':<span>');
		iattrs.options.forEach( o => {
			var sopt = $('<span>').addClass('radio-list-option').html( ck( o == opt[optid]) + ' ' + o ).prop('optid',o).on('click', function(){
				opt[optid] = $(this).prop('optid');
				console.log( 'optid', optid, 'v', opt);
				options();
			})
			radio.append( sopt );
		})
	}
	options();
	div.append( radio );
}


function listAttributes( div, iattrs, attributes, title )
{
    div.html('');
    div.addClass('text-attrs');
    if( iattrs )
    {
        var choose = $('<DIV>');
		// choose.append($('<DIV>').addClass('cchoosetitle').addClass('cchooselabel').html('<h5>'+title+'</h5>'));
		choose.append($('<DIV>').addClass('cchoosetitle').addClass('cchooselabel'));
        choose.css({width:px(div.width())})
        div.append( choose );

        iattrs.forEach( function(a){
            a.optional = bool(a.optional);
            a.allowNew = bool(a.allowNew);
            if( !( a.label in attributes) && !a.optional ) attributes[a.label] = null;
            var label = a.label;
            // if( !a.optional ) label = '*'+label;
            var aline = $('<div>').html('<div class="doc-attributes">'+label+'</div>');
            var select = $('<select class="mmdb-select mmd-form iselect">');
            select.prop('id','select'+label);
            aline.append(select);
            if( !a.options ) a.options = ["no", "yes"];
			var placeholder = a.placeholder || '(select)';
			select.append( $('<option>').prop('value','').html( placeholder ));
            var opts = {};
			if( attributes[a.label] && a.options.indexOf(attributes[a.label]) == -1 )
				a.options.push(attributes[a.label])
            a.options.forEach(function(aopt,idx){
                opts[aopt] = 1;
                select.append( $('<option>').prop('value',aopt).html( aopt ));
            });
			// console.log('ATTR', attributes[a.label], a.options );
            if( a.allowNew )
            {
                select.append( $('<option>').prop('value','_new').html( '(Add new '+ a.label + ')' ));
            }
            select.val(attributes[a.label])
            select.on('change', function(){
                // selectStyle(select);
                val = select.val();
                if( val == '' ) val = null;
                attributes[a.label] = val;
                if( val != '_new' ) text.hide();
                else
                {
                    text.show();
                    text.focus();
                }
				changed();
            });
            var text = $('<INPUT TYPE="text">').prop('id','selectText'+a.label).addClass('iselect-text').hide();
            text.on('keyup',function(ev)
            {
                if( ev.keyCode == 13 )
                {
					textSave();
                }
            });
			text.on('change',textSave)
			function textSave()
			{
				val = text.val().trim();
				if( val == '' ) return myAlert( 'Value Required', 'Please select the new value for attribute "'+ a.label +'"' );
				text.hide();
				if( !(val in opts) )
				{
					a.options.push( val );
				}
				attributes[a.label] = val;
				listAttributes( div, iattrs, attributes );
			}
            aline.append(text);
            choose.append(aline);
        });
    }
    // div.append( $('<br><h5>Aditional Notes</h5>') );
	// var addNotes = $('<TEXTAREA>').addClass('inote-text');
	var addNotes = descriptor.reviewMode ? $('#reviewer_notes') : $('#annotator_notes');
    addNotes.val(attributes["Aditional Notes"] || "" );
    addNotes.on('change', updateNotes ).on('blur', updateNotes );
    let m = descriptor.messages || [];
    if( m.length && m[m.length-1][1] == addNotes.val() ) addNotes.val('');
    function updateNotes(){ attributes["Aditional Notes"] = $(this).val(); changed() };
    // div.append( addNotes );
}

var changed =  function(){ console.log( 'changed', Date.now())};


var myAlert = function( title, body, btn, callback, btn2, callback2, btn3, callback3 )
{
	$('.modal-title').html(title);
    var modal = window.$("#myModal");
	if( typeof(body) == 'string' ) $('.modal-body').html(body);
	else $('.modal-body').html('').append(body);
    $('.waveinterface').css('z-index', 0);
	modal.modal({
		backdrop: 'static',
		keyboard: false,
	})
	modal.find(".myclose").css({position:'absolute',right:px(10),top:px(0)}).hide();
	modal.find(".btn").hide();
    modal.find('.btn-primary').removeClass('btn-primary');
    modal.find('.btn-secondary').removeClass('btn-secondary');
    modal.find('.btn-danger').removeClass('btn-danger');

    function setButton( id, label, callback ) {
        var bid = '#modal-close'+(id||'');
        var but = modal.find(bid);
        if (!label) label = '';
        var isDanger = label.match(/^\*/);
        var isPrimary = label.match(/^\^/);
        if( isPrimary ) but.addClass('btn-primary')
        else if( isDanger ) but.addClass('btn-danger')
        else but.addClass('btn-secondary');
        label = label.replace(/^[\^\*]/, '');
        but.html(label);
        if( label ) but.show();
        else but.hide();
        but.off('click');
       	if( callback ) but.on('click', callback );
    }
	if( !btn ) btn = 'Ok';
    setButton( '', btn, callback );
    setButton( 2, btn2, callback2 );
    setButton( 3, btn3, callback3 );
}
function restoreWaveRegionVisibility() {
    if (tempVisibleRegion && originalEyeState) {
        console.log('Restoring visibility for region:', originalEyeState.regionId, 'Original state was visible:', originalEyeState.wasVisible);
        if (originalEyeState.wasVisible) {
            originalEyeState.eyeElement.removeClass('fa-eye fa-eye-slash').addClass('fa-eye');
            
            if (tempVisibleRegion.element) {
                tempVisibleRegion.element.style.display = 'block';
                tempVisibleRegion.element.style.visibility = 'visible';
                tempVisibleRegion.element.style.opacity = '1';
            }
            
            $('div[data-id="' + tempVisibleRegion.id + '"]').css({
                'display': 'block',
                'visibility': 'visible',
                'opacity': '1'
            });
            
            if (tempVisibleRegion.wrapper) {
                tempVisibleRegion.wrapper.style.display = 'block';
            }
            
            tempVisibleRegion.data.visible = true;
        } else {
            originalEyeState.eyeElement.removeClass('fa-eye fa-eye-slash').addClass('fa-eye-slash');
            
            if (tempVisibleRegion.element) {
                tempVisibleRegion.element.style.display = 'none';
                tempVisibleRegion.element.style.visibility = 'hidden';
                tempVisibleRegion.element.style.opacity = '0';
            }
            
            $('div[data-id="' + tempVisibleRegion.id + '"]').css({
                'display': 'none',
                'visibility': 'hidden',
                'opacity': '0'
            });
            
            if (tempVisibleRegion.wrapper) {
                tempVisibleRegion.wrapper.style.display = 'none';
            }
            
            tempVisibleRegion.data.visible = false;
        }
        
        tempVisibleRegion = null;
        originalEyeState = null;
    }
}


var myAlertClose = function(callback) {
	function onModalHidden(ev) {
		$('#myModal').off('hidden.bs.modal', onModalHidden); 
        restoreWaveRegionVisibility();
		$('.waveinterface').css('z-index', '');
		if (callback) {
			callback(ev);
		}
	}
	
	$('#myModal').on('hidden.bs.modal', onModalHidden);

	setTimeout(function () {
		$('#myModal').modal('hide');
	}, 10);
}

function saveClipboard( txt )
{
	var input = $('<textarea>').val(txt).css({position:'absolute',top:px(-10000),left:px(-100000)});
	$(document.body).append(input);
	input.select();
	document.execCommand("copy");
	setTimeout( function(){
		input.remove();
	}, 100 );
}
/**
 * Generates a plain text file from the current transcript data
 * and triggers a download in the browser.
 */
function exportDraftText() {
    // 1. Check if there is transcript data available.
    if (!window.descriptor || !window.descriptor.transcript || window.descriptor.transcript.length === 0) {
        // Use the existing alert function for a consistent UI.
        myAlert('Export Error', 'There is no transcript data to export.');
        return;
    }

    // 2. Map the structured transcript data back to the "speaker: dialogue" string format.
    // This uses the cleaned and processed text from the right-side panel.
    const draftContent = window.descriptor.transcript.map(line => {
        return `${line.speaker}: ${line.dialogue}`;
    }).join('\n');

    // 3. Create a Blob (a file-like object) from the text content.
    const blob = new Blob([draftContent], { type: 'text/plain;charset=utf-8' });

    // 4. Create a temporary link element to trigger the file download.
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'exported_transcript_draft.txt'; // Set the default filename.

    // 5. Programmatically click the link to start the download, then clean up.
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href); // Free up memory.
}
// PASTE THE NEW FUNCTIONS HERE:
/**
 * Converts seconds into HH:MM:SS:FF timecode format.
 * @param {number} secs - The time in seconds.
 * @param {number} [fps=30] - Frames per second for the calculation.
 * @returns {string} The formatted timecode.
 */
function ftime(secs, fps = 30) {
    if (typeof secs !== 'number' || isNaN(secs)) {
        return '00:00:00:00';
    }
    
    // --- FIX: This new implementation avoids floating-point errors from fractional seconds ---
    
    // 1. Convert total seconds to total frames, rounding to the nearest whole frame.
    // This is the key step to correct for floating-point inaccuracies from previous calculations.
    const totalFrames = Math.round(secs * fps);

    // 2. Calculate HH:MM:SS:FF from the integer-based total frames. This is more stable.
    const hh = Math.floor(totalFrames / (3600 * fps));
    const mm = Math.floor((totalFrames % (3600 * fps)) / (60 * fps));
    const ss = Math.floor((totalFrames % (60 * fps)) / fps);
    const ff = totalFrames % fps;

    return [hh, mm, ss, ff]
        .map(v => v.toString().padStart(2, '0'))
        .join(':');
}

/**
 * Converts HH:MM:SS:FF timecode format back to seconds.
 * @param {string} timecode - The timecode string.
 * @param {number} [fps=30] - Frames per second for the calculation.
 * @returns {number} The time in seconds.
 */
function timecodeToSeconds(timecode, fps = 30) {
    if (typeof timecode !== 'string' || !timecode.includes(':')) {
        return parseFloat(timecode) || 0; // Return if it's already a number
    }
    const parts = timecode.split(':').map(Number);
    if (parts.length === 4) {
        const [hh, mm, ss, ff] = parts;
        return hh * 3600 + mm * 60 + ss + (ff / fps);
    }
    return 0;
}

// TAXONOMY MODE: New wrapper function to choose the export method.
function exportData(nocheck) {
    // This is the switch. It checks if Taxonomy mode is on.
    if (window.descriptor.Taxonomy) {
        // If yes, call the new, advanced export function.
        return exportDataWithTaxonomy(nocheck);
    } else {
        // If no, call the original function we just renamed.
        return exportDataSimple(nocheck);
    }
}
function exportDataSimple(nocheck) {
    var ret = {};

    if (declined) {
        ret.taskDeclined = true;
        ret.declineReason = declineReason;
    }
    
    // =================================================================================
    // === FINAL, SERVER-SAFE FIX: Structure data inside 'streams' to avoid miscounting ===
    // =================================================================================

    const aggregationStream = [];
    if (descriptor.transcript && Array.isArray(descriptor.transcript)) {
        descriptor.transcript.forEach(line => {
            const speakerTag = (line.speaker && line.speaker.trim()) ? line.speaker.trim() : 'Unknown Speaker';
            // This simple structure is ONLY for the backend statistics.
            aggregationStream.push({ tag: speakerTag });
        });
    }

    // Both data sets MUST go inside the 'streams' object to be saved by the server.
    ret.streams = {
        // 1. This 'default' stream is for the backend dashboard. It is an ARRAY,
        // so the backend's simple script will iterate it and count the tags.
        'default': aggregationStream,
        
        // 2. This is the critical change. We store the tool's private data as an OBJECT,
        // NOT an array. The backend script is looking for arrays to iterate.
        // By making this an object, the script will skip it, PREVENTING double-counting.
        'tool_data': {
            transcript: clone(descriptor.transcript)
        }
    };
    
    // =================================================================================
    // === END OF FIX ==================================================================
    // =================================================================================

    // Keep other important metadata
    ['videoSource', 'audioSource', 'DRMURL', 'DRMServerURL', 'mediaAttributes'].forEach(a => {
        if (tagData[a]) ret[a] = clone(tagData[a]);
    });
    ret.jobStart = descriptor.jobStart;
    ret.sessionTime = (getsec() - descriptor.sessionStart);
    ret.elapsedTime = descriptor.elapsedTime + ret.sessionTime;
    ret.tsSeconds = true;
    ret.updateTime = getsec();
    ret.metadata = descriptor.metadata;

    return ret;
}
// TAXONOMY MODE: New export function for taxonomy mode.
function exportDataWithTaxonomy(nocheck) {
    var ret = {};
    var check = nocheck || declined ? false : true;
    
    // --- Decline Logic ---
    if( declined ) { /*... same decline logic as original ...*/ }

    // --- Reviewer Logic ---
    if( descriptor.reviewMode ) { /*... same review logic as original ...*/ }
   	if ($('#annotator_notes').val().trim() > '') { /*... same notes logic as original ...*/ }

    // --- Required Attributes Check ---
    if( tagData.attributes ) { /*... same attributes check as original ...*/ }

    // --- Annotation Data Collection (Taxonomy Version) ---
    var ranges = [];
    for (var k in wavesurfer.regions.list) {
        var r = wavesurfer.regions.list[k];
        if (!r.data || !r.data.track) continue;
        var notes = r.data.notes || (window.regionNotes && window.regionNotes[k]) || '';
        
        // This is a placeholder for your actual taxonomy data lookup.
        // Since code 1 doesn't have `window.tagData_Global`, we'll leave it as a placeholder.
        var matchedTag = null; 
        
        ranges.push({
            id: k, start: r.start, end: r.end, tag: r.data.tag || "", text: r.data.text || "",
            confidence: r.data.confidence || 1, track: r.data.track, notes: notes,
            mode: r.data.mode !== undefined ? r.data.mode : 0, // Include mode information
            TagCode: matchedTag ? matchedTag.TagCode : "-", TagTree: matchedTag ? matchedTag.TagTree : "-"
        });
    }
    ranges.sort((a, b) => a.start - b.start);

    // --- Prepare Streams for Export (Taxonomy Version) ---
    if (!tagData.streams) tagData.streams = {};
    if (currentMode && currentMode.name) {
        tagData.streams[currentMode.name] = [];
        for (var r of ranges) {
            tagData.streams[currentMode.name].push({
                start_time: ftime(r.start),
                end_time: ftime(r.end),
                tag_name: r.text,
                tag_code: r.TagCode,  // Taxonomy-specific field
                tag_tree: r.TagTree,  // Taxonomy-specific field
                notes: r.notes,
                mode: r.mode !== undefined ? r.mode : 0 // Include mode in export
            });
        }
    }

    // --- Final Validation and Data Packaging ---
    if( check ) { /*... same validation logic as original ...*/ }

    ['videoSource', 'audioSource', 'DRMURL', 'DRMServerURL', 'streams', 'mediaAttributes'].forEach(a => {
        if (tagData[a]) ret[a] = clone(tagData[a]);
    });
    
    ret.jobStart = descriptor.jobStart;
    ret.sessionTime = (getsec() - descriptor.sessionStart);
    ret.elapsedTime = descriptor.elapsedTime + ret.sessionTime;
    ret.tsSeconds = true;
    ret.updateTime = getsec();
    ret.metadata = descriptor.metadata;
    return ret;
}

function setHierarchy()
{
    var cid = 1000;
    $('.hierarchy').html('<div class="dropdown hierarchy-select" id="hierarchy-classification"><button type="button" class="btn btn-secondary dropdown-toggle" id="example-one-button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button><div class="dropdown-menu" aria-labelledby="example-one-button"><div class="hs-searchbox"><input type="text" class="form-control" autocomplete="off"></div><div class="hs-menu-inner"></div></div><input class="d-none" name="example_one" readonly="readonly" aria-hidden="true" type="text"/></div>');
    var clf = $('#hierarchy-classification');
    clf.hierarchySelect({
        width: '100%',
        resetSearchOnSelection: true,
        onChange: change,
        // onHide: hidden,
        // onShow: shown,
    });
	clf.find('button').on('click',function(){
		clf.find('.active').removeClass('active');
	})
    var hinst = clf.prop('instance');
	// clf.find('button').html(descriptor.buttonLabel);
	function setAddLabel()
	{
		clf.find('button').html('Add Track');
	}
	setAddLabel();
    function change( id )
    {
        // clf.find('button').html('Add Other Skills');
        // clf.find('button').html('Close');
        // addTag(id);
        // hinst.noToggle();
        // setTimeout( function(){ hinst.noToggle = false}, 1 )
        // hinst.dropDown();
        // setTimeout( function(){hinst.dropDown()}, 1 );
		window.trackObj.setTrack( id );
        console.log( 'change', id );
		setAddLabel();
    }
    function hidden(inst){
        console.log( 'hidden' );
        // inst.$button.html(descriptor.buttonLabelExtra)
        // hinst.$searchbox.val('').trigger('propertychange');
        // $('#tags').show();
    }
    function shown(inst){
        console.log( 'shown', inst );
        // inst.$button.html('Close')
        // $('#tags').hide();
    }
    var opts = clf.find('.hs-menu-inner');
    function addOpt( path, leaf )
    {
		// console.log( 'addOpt', path.join('/'), leaf )
        var tid = path.join(' / ');
        // idsFromString[tid] = id;
        // classificationIds[tid] = {path:path, level:level, text:text};
        // // var mydisabled = level == 1 || text == '-';
        // var mydisabled = text == '-';
        // // var oclass = 'dropdown-item tag-level'+level+ ' tag-parent-'+parent;
        // // if( mydisabled ) oclass += ' mydisabled';
        // // var otxt = '<a class="'+oclass+'" id="hid'+id+'" "data-value"="'+tid+'" "data-level"="'+level+'" href="#"></a>';
        // // console.log( otxt );
        // // console.log( 'addOpt', text, level, path, mydisabled, id, parent );
		//
		var text = path.join('/');
		var level = path.length;
        var opt = $('<a class="dropdown-item" href="#">');
        opt.html(text).attr({
            'data-value':tid,
            'data-level':path.length,
        });
		if( !leaf ) opt.addClass('disabled').addClass('node');
        opt.prop('id', 'hid'+tid )
        opt.addClass('tag-level'+level);
        opt.addClass('tag-hierarchy');
        // if( !leaf ) opt.addClass('mydisabled');
        opts.append(opt);
		opt.css({display:'block'})
    }
    function tree( n, path )
    {
        console.log( 'tree', n, path );
		if( isobj( n ) )
		{
			addOpt( path, 0 );
			for( var k in n )
			{
				path.push( k );
				tree( n[k], path )
				path.pop();
			}
		}
		else if( isarray( n ) )
		{
			addOpt( path, 0 );
			for( var i of n )
			{
				path.push( i );
				addOpt( path, 1 );
				path.pop();
			}
		}
		else if( isstring( n ) )
		{
			path.push( n );
			addOpt( path, 1 );
			path.pop();
		}
        // var level = path.length+1;
        // var keys = Object.keys(n);
        // keys.sort();
        // for( var i = 0 ; i < keys.length ; i++ )
        // {
        //     var s = keys[i];
        //     // console.log( 's', s )
        //     var isleaf = ('_value_' in n[s]);
        //     if( isleaf )
        //     {
        //         ftext = n[s]._value_.text;
        //         if( n[s]._value_.alias && n[s]._value_.alias.length > 0 )
        //             ftext += '<span class="alias">'+n[s]._value_.alias+'</span>';
        //         fpath = clone(n[s]._value_.path);
        //         addOpt( ftext, level, fpath, cid++, parent );
        //     }
        //     else {
        //         text = s;
        //         if( text != '-' ) text = beautify(text);
        //         npath = clone(path);
        //         npath.push(s);
        //         var nodeId = cid++;
        //         addOpt( text, level, npath, nodeId, parent );
        //         tree( n[s], npath, nodeId );
        //     }
        // }
    }
    opts.html('');
    console.log( 'treeStart' );
	// console.log( 'hierarchy', hierarchy )
    tree( descriptor.hierarchy, [] );
    console.log( 'treeEnd' );
    $('.dropdown-item').hide();
	$('.tag-hierarchy').show();
}


function modal(title, body, btnTxt, callback) {
    if (!btnTxt) btnTxt = 'Ok';
    return myAlert(title, body, btnTxt, callback);

}

function modalWait(callback) {
    $('#myModal').on('hidden.bs.modal', function (ev) {
        $('#myModal').off('hidden.bs.modal');
        callback(ev);
    });
}


$('.main').hide();

var totalModes = 0;
window.totalModes = totalModes;
/**
 * Populates the .media-metadata element with data from the descriptor.
 * This function is adapted from the working logic in code 2.
 */
function populateMetadataHeader() {
    // 1. Safely merge metadata from both possible locations into a new object.
    const mergedMetadata = {
        ...(descriptor.media && descriptor.media.metadata ? descriptor.media.metadata : {}),
        ...(descriptor.metadata || {})
    };

    // 2. Only proceed if we found any metadata to display.
    if (Object.keys(mergedMetadata).length > 0) {
        // 3. Find the target HTML element that is already on the page.
        const targetElement = $('.media-metadata');

        // 4. Check if the element exists before trying to populate it.
        if (targetElement.length > 0) {
            // Build the display string: "<b>Key:</b> Value&nbsp;&nbsp;&nbsp;<b>Key2:</b> Value2"
            const outputHtml = Object.entries(mergedMetadata)
                .map(([key, value]) => `<b>${key}:</b> ${value}`)
                .join('&nbsp;&nbsp;&nbsp;&nbsp;');

            // Set the content of the target element.
            targetElement.html(outputHtml);

            // Add the "click-to-copy" functionality from the reference code.
            targetElement.attr('title', 'Click to copy full metadata')
                .off('click')
                .on('click', function() {
                    const copyText = JSON.stringify(mergedMetadata, null, 2);
                    saveClipboard(copyText);
                    myAlert('Metadata Copied', 'The full metadata has been copied to your clipboard.');
                });
        } else {
            // This warning is helpful for debugging if the HTML is missing the target element.
            console.warn("Metadata target element '.media-metadata' not found in the DOM.");
        }
    }
}
function init() {
     transcriptionMode = descriptor.transcriptionMode ? true : false;
    
    transcriptionMode = descriptor.transcriptionMode ? true : false;
    
    // =================================================================================
    // === FINAL, SERVER-SAFE Transcript Loading Logic                               ===
    // This block correctly finds the transcript data whether it's an initial load  ===
    // or an auto-save resume, preventing it from disappearing on refresh.          ===
    // =================================================================================

    let foundTranscript = null;
    let streamsSource = null;

    // First, determine the correct source for the 'streams' object.
    if (descriptor.annotations && descriptor.annotations.streams) {
        // Case 1: Initial load from a submitted task. Data is nested.
        streamsSource = descriptor.annotations.streams;
    } else if (descriptor.streams) {
        // Case 2: Resuming from an auto-save. Data is at the top level.
        streamsSource = descriptor.streams;
    }

    // Now, look for our specific transcript data within the new object structure.
    if (streamsSource && streamsSource.tool_data && streamsSource.tool_data.transcript && Array.isArray(streamsSource.tool_data.transcript)) {
        foundTranscript = clone(streamsSource.tool_data.transcript);
        console.log("SUCCESS: Loaded transcript from [streams.tool_data.transcript]");
    }
    
    // Assign the found transcript or initialize an empty array if nothing was found.
    descriptor.transcript = foundTranscript || [];
    if (!foundTranscript) {
        console.log("No saved transcript found in any known location, initializing as empty.");
    }
    
    // =================================================================================
    // === End of Loading Logic                                                      ===
    // =================================================================================
    
    if (!$('#wavesurfer-selection-styles').length) { /* ... styles ... */ }
    
	$('crowd-form').hide();
	if( descriptor.DRMData && !descriptor.DRMData.init ) {
		descriptor.DRMData.init = function(){ init(); };
		return;
	}
	if( transcriptionMode )$('video').addClass('video-transcript');

    // Make sure the old, problematic block is removed from here.
    
    totalModes = [{
        id: 0,
        name: 'Transcript',
        mode: 'Transcript',
        type: 'transcription'
    }];
// var transcriptionData = []; 
// ADD THIS ENTIRE FUNCTION
/**
 * Displays a "Task Locked" modal alert if editing is blocked.
 */
function showLockAlert() {
    // This check is a safeguard, but the function should only be called when blockEdit is true.
    if (!descriptor || !descriptor.blockEdit) return; 

    let lockTxt = "You don't own this task on its current state. Therefore annotations can't be created or modified.";
    if (descriptor.task_can_claim) {
      lockTxt += `<br><br>You may <b>claim</b> the task and become the task owner as <b>${descriptor.task_role}</b>`;
    }
    
    // Use the existing myAlert function (which you've mapped to frm.myAlert)
    myAlert('<i class="fa fa-lock alert-icon"></i> Task Locked', lockTxt, 'Ok');
};
function setupTranscriptionImport() {
    // --- Helper functions for cleaning imported text ---
    function removeFillerWords(text) {
        const fillerWords = ["aia", "erm", "eh", "mhm", "mmm", "ah", "um", "uh", "like", "you know"];
        let processedText = text;
        fillerWords.forEach(word => {
            const regex = new RegExp(`\\b${word}\\b`, 'gi');
            processedText = processedText.replace(regex, '');
        });
        return processedText.replace(/\s+/g, ' ').trim();
    }

    function replaceChannelText(text) {
        let processedText = text;
        processedText = processedText.replace(/channel\s*1\s*:/gi, 'CCP 1:');
        processedText = processedText.replace(/channel\s*2\s*:/gi, 'CM 1:');
        return processedText.replace(/\s{2,}/g, ' ');
    }

    function removePunctuationMarks(text) {
        return text.replace(/[.,!?]/g, '').replace(/\s+/g, ' ').trim();
    }

    // 1. Create a container for the buttons for better layout control.
    const buttonContainer = $('<div class="transcript-controls-container mb-2"></div>');

    // 2. ★★★ THIS IS THE FIX: Buttons are now divs for easier styling ★★★
    const importButton = $('<div class="action-btn" id="import-draft-btn" title="Import Draft File"><i class="fa fa-download"></i> Import</div>');
    const exportButton = $('<div class="action-btn" id="export-draft-btn" title="Export Draft"><i class="fa fa-upload"></i> Export</div>');
    const alignButton = $('<button class="btn btn-sm transcript-labeled-btn" id="align-btn" style="display:none;" title="Align Transcript"><i class="fa fa-link"></i> Align</button>'); // Kept as button, but hidden
    const addRowButton = $('<div class="action-btn" id="add-row-btn" title="Add New Dialogue Row"><i class="fa fa-plus"></i> Add</div>');
    const fileInput = $('<input type="file" accept=".txt" style="display: none;" id="draft-file-input">');

    // Add the buttons to their container and add to the page.
    buttonContainer.append(importButton, exportButton, alignButton, addRowButton);
    $('#reportpanel').before(buttonContainer, fileInput);

    importButton.on('click', function() {
        if (window.descriptor.blockEdit) return showLockAlert();
        fileInput.click();
    });

    exportButton.on('click', function() {
        if (window.descriptor.blockEdit) return showLockAlert();
        exportDraftText();
    });
    
    alignButton.on('click', function() {
        handleAlignment();
    });
    addRowButton.on('click', function(e) {
        e.stopPropagation();
        if (window.descriptor.blockEdit) return showLockAlert();
        addNewRow();
    });
    fileInput.on('change', function(event) {
        const file = event.target.files[0];
        if (!file) return;
        if (!file.name.toLowerCase().endsWith('.txt')) {
            myAlert('Invalid File Type', 'This feature only supports .txt files. Please select a valid transcript file.');
            $(this).val('');
            return;
        }
        const reader = new FileReader();
        reader.onload = function(e) {
            let rawContent = e.target.result;
            let macroApplied = false;

            const languageMap = {
                'en': '_en', 'english': '_en', 'English': '_en', 'es': '_es', 'spanish': '_es', 'Spanish': '_es',
                'fr': '_fr', 'french': '_fr', 'French': '_fr', 'ja': '_ja', 'japanese': '_ja', 'Japanese': '_ja'
            };

            const metadata = {
                ...(descriptor.media?.metadata || {}),
                ...(descriptor.metadata || {})
            };

            const macroKey = Object.keys(metadata).find(k => k.toLowerCase() === 'macro');
            const macroValue = macroKey ? metadata[macroKey] : null;

            if (macroValue) {
                const macroToRun = languageMap[String(macroValue).toLowerCase().trim()];
                if (macroToRun && macros[macroToRun]) {
                    console.log(`Applying macro '${macroToRun}' based on metadata value: '${macroValue}'`);
                    rawContent = macros[macroToRun](rawContent);
                    macroApplied = true;
                } else {
                    console.log(`Metadata specified macro '${macroValue}', but no matching macro was found. Proceeding without a macro.`);
                }
            }
            
            const rawLines = rawContent.split('\n').filter(line => line.trim() !== '');
            const oldSpeakerMap = { 'speaker1': 'Customer', 'speaker2': 'Representative' };

            descriptor.transcript = rawLines.map((line, index) => {
                const processedLine = macroApplied ? line : replaceChannelText(line);
                const match = processedLine.match(/^(.*?):\s*(.*)/);
                let speaker = 'Unknown';
                let dialogue = processedLine;

                if (match) {
                    speaker = match[1].trim();
                    dialogue = match[2].trim();
                }
                
                if (oldSpeakerMap[speaker]) {
                    speaker = oldSpeakerMap[speaker];
                }
                
                let finalDialogue = dialogue;
                if (!macroApplied) {
                    let cleanedDialogue = removeFillerWords(dialogue);
                    finalDialogue = removePunctuationMarks(cleanedDialogue);
                }

                return {
                    id: `line-${index}`, speaker: speaker, dialogue: finalDialogue,
                    start: null, end: null, words: []
                };
            }).filter(item => item.dialogue);

            waveReport();
            changed();
            fileInput.val('');
            $('#align-btn').hide();
        };
        reader.readAsText(file);
    });
}

// --- START: Language-Specific Macro Definitions ---
const macros = {
    _en: function(text) {
        function removeWords(text) {
            const wordsToRemove = ["um", "mhm", "uh", "ah", "mhm", "hmm", "hm"];
            let processedText = text;
            wordsToRemove.forEach(word => {
                const regex = new RegExp(`\\b${word}\\b`, 'gi');
                processedText = processedText.replace(regex, '');
            });
            return processedText;
        }

        function replaceChannelText(text) {
            let processedText = text.replace(/channel 1:\s*/gi, 'CCP 1: ');
            processedText = processedText.replace(/channel 2:\s*/gi, 'CM 1: ');
            return processedText;
        }

        function replaceMultipleSpaces(text) {
            // FIX: Only replace multiple spaces, not newlines
            return text.replace(/ {2,}/g, ' ');
        }

        function removePunctuationMarks(text) {
            const charsToRemove = [".", ",", "!", "?"];
            let processedText = text;
            charsToRemove.forEach(char => {
                const regex = new RegExp(`\\${char}`, 'g');
                processedText = processedText.replace(regex, '');
            });
            return processedText;
        }

        let processedText = text;
        processedText = removeWords(processedText);
        processedText = replaceChannelText(processedText);
        processedText = removePunctuationMarks(processedText);
        
        // FIX: Process line by line to preserve newlines
        return processedText.split('\n').map(line => line.replace(/ {2,}/g, ' ').trim()).join('\n');
    },
    _fr: function(text) {
        function removeWords(text) {
            const wordsToRemove = ["ben", "bah", "bein", "mhm", "mmm", "ah", "hein", "oh", "euh", "beh", "hmm"];
            let processedText = text;
            wordsToRemove.forEach(word => {
                const regex = new RegExp(`\\b${word}\\b`, 'gi');
                processedText = processedText.replace(regex, '');
            });
            return processedText;
        }

        function replaceChannelText(text) {
            let processedText = text.replace(/channel 1:\s*/gi, "CCP 1: ");
            processedText = processedText.replace(/channel 2:\s*/gi, "CM 1: ");
            return processedText;
        }

        function removePunctuationMarks(text) {
            const charsToRemove = [".", ",", "!", "?", "-"];
            let processedText = text;
            charsToRemove.forEach(char => {
                const escapedChar = char.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                const regex = new RegExp(escapedChar, 'g');
                processedText = processedText.replace(regex, '');
            });
            return processedText;
        }

        let result = text;
        result = removeWords(result);
        result = replaceChannelText(result);
        result = removePunctuationMarks(result);
        
        return result.split('\n').map(line => line.replace(/ {2,}/g, ' ').trim()).join('\n');
    },
    _ja: function(text) {
        function replaceChannelText(text) {
            let result = text.replace(/Channel1:/g, "CCP 1: ");
            result = result.replace(/Channel2:/g, "CM 1: ");
            return result;
        }

        let result = text;
        result = replaceChannelText(result);
        
        // FIX: Process line by line to preserve newlines
        return result.split('\n').map(line => line.replace(/ {2,}/g, ' ').trim()).join('\n');
    },
_es: function(text) {
    function removeWords(text) {
        const wordsToRemove = ["aja", "erm", "eh", "mhm", "mmm", "ah"];
        let result = text;
        wordsToRemove.forEach(word => {
            const regex = new RegExp(`\\b${word}\\b`, 'gi');
            result = result.replace(regex, '');
        });
        return result;
    }

    function replaceChannelText(text) {
        let result = text.replace(/channel 1:\s*/gi, 'CCP 1: ');
        result = result.replace(/channel 2:\s*/gi, 'CM 1: ');
        return result;
    }

    function removePunctuationMarks(text) {
        // --- THIS IS THE FIX ---
        // Added "¿" and "¡" to the list of characters to remove
        const charsToRemove = [".", ",", "!", "?", "¿", "¡"];
        let result = text;
        charsToRemove.forEach(char => {
            const regex = new RegExp(`\\${char}`, 'g');
            result = result.replace(regex, '');
        });
        return result;
    }

    let result = text;
    result = removeWords(result);
    result = replaceChannelText(result);
    result = removePunctuationMarks(result);

    // Process line by line to preserve newlines
    return result.split('\n').map(line => line.replace(/ {2,}/g, ' ').trim()).join('\n');
},
};
// --- END: Language-Specific Macro Definitions ---
async function handleAlignment() {
    // const statusDiv = $('#align-status');
    const alignButton = $('#align-btn');

    // 1. Get the audio URL
    const audioUrl = window.descriptor.audioSource;
    if (!audioUrl) {
        // statusDiv.text('Error: Audio source URL not found.');
        return;
    }

    // 2. Get the CLEANED transcript text from our global data object
    const transcriptText = descriptor.transcript.map(line => `${line.speaker}: ${line.dialogue}`).join('\n');
    if (!transcriptText) {
        // statusDiv.text('Error: No transcript text found to align.');
        return;
    }

    // 3. Prepare the payload with BOTH audio URL and the cleaned text
    const payload = {
        audioUrl: audioUrl,
        transcriptText: transcriptText // Sending the cleaned text is essential
    };

    console.log("Sending payload to /align:", payload);

    // statusDiv.text('Aligning... This may take a moment.');
    alignButton.prop('disabled', true).text('Working...');

    try {
        const backendUrl = `http://${window.location.hostname}:8090/align`;
        const response = await fetch(backendUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || 'Alignment failed on server.');
        }
        console.log("response-->",response);
        
        const alignedWords = await response.json();
    
        console.log("response==>",alignedWords);

        // 4. Success! Update the UI with the new timestamps.
        updateTranscriptWithTimestamps(alignedWords);
        
        // statusDiv.text('Alignment successful! Timestamps added.');
        alignButton.hide();

    } catch (error) {
        console.error('Error during alignment:', error);
        // statusDiv.text(`Alignment Error: ${error.message}`);
    } finally {
        alignButton.prop('disabled', false).text('Align Transcript');
    }
}

/**
 * Merges the aligned word timestamps from the backend with the existing transcript data.
 * This version correctly maps the sequence of words and updates all relevant data objects.
 * @param {Array} alignedWords - The array of {word, start, end} objects from the /align endpoint.
 */
function updateTranscriptWithTimestamps(alignedWords) {
    console.log('Updating transcript with aligned words:', alignedWords);
    
    if (!descriptor.transcript || !alignedWords) {
        console.error("Update failed: Missing transcript data or aligned words.");
        return;
    }

    const newTranscript = [];
    let wordCounter = 0; 

    descriptor.transcript.forEach(originalLine => {
        console.log('Processing line:', originalLine);
        
        // Determine how many words were in the original draft line.
        const wordsInOriginalLine = originalLine.dialogue.split(/\s+/).filter(Boolean).length;

        console.log(`Original line had ${wordsInOriginalLine} words.`);
        // If the line was empty, skip it.
        if (wordsInOriginalLine === 0) return;

        // Take a "slice" of the API's words corresponding to this line's original word count.
        const wordsForThisLine = alignedWords.slice(wordCounter, wordCounter + wordsInOriginalLine);
        wordCounter += wordsInOriginalLine; // Advance our counter for the next line.
        console.log('Matched words for this line:', wordsForThisLine);
        if (wordsForThisLine.length > 0) {
            // Create a new, clean line object using the API's authoritative data.
            const newLine = {
                id: originalLine.id,
                speaker: originalLine.speaker,
                // The new dialogue is built from the API's corrected text.
                dialogue: wordsForThisLine.map(w => w.word).join(' '),
                // The timestamps come directly from the API words.
                start: wordsForThisLine[0].start,
                // --- CORRECTED TYPO HERE ---
                end: wordsForThisLine[wordsForThisLine.length - 1].end,
                words: wordsForThisLine.map(w => ({ text: w.word, start: w.start, end: w.end }))
            };
            console.log('Constructed new line:', newLine);
            newTranscript.push(newLine);
        }
    });

    // Replace the old, untimed transcript with our newly constructed, correct one.
    descriptor.transcript = newTranscript;

    // Immediately update the 'streams' object so that auto-save has the correct data.
    if (!descriptor.streams) descriptor.streams = {};
    descriptor.streams.transcript = clone(descriptor.transcript);

    console.log('FINAL SUCCESS: Transcript has been rebuilt and timed.', descriptor.transcript);

    // Refresh the UI and trigger the auto-save.
    waveReport();
    changed();
}

/**
 * Checks if the current transcript data is missing alignment timestamps.
 * This is the key function to determine if the "Align" button should be shown on page load.
 * @returns {boolean} - True if the transcript exists but lacks timestamps, false otherwise.
 */
function checkIfTranscriptNeedsAlignment() {
    // 1. If there's no transcript or it's empty, no alignment is needed.
    if (!descriptor.transcript || descriptor.transcript.length === 0) {
        return false;
    }

    // 2. We'll check the first line for signs of alignment. 
    //    This is an efficient way to check the whole file's state.
    const firstLine = descriptor.transcript[0];

    // 3. A key indicator of an unaligned draft is that it has dialogue text,
    //    but the 'words' array (which holds timestamps) is either missing, empty,
    //    or the words inside it don't have a 'start' time.

    // If the 'words' array doesn't exist or is empty, it definitely needs alignment.
    if (!firstLine.words || firstLine.words.length === 0) {
        // We must ensure there is actually dialogue to be aligned.
        return firstLine.dialogue && firstLine.dialogue.trim().length > 0;
    }

    // If the 'words' array exists, check the first word for a valid timestamp.
    // If the 'start' property is null or not a number, it needs alignment.
    const firstWord = firstLine.words[0];
    if (typeof firstWord.start !== 'number' || firstWord.start === null) {
        return true;
    }

    return false;
}
// REPLACE THE FUNCTION AROUND LINE 1612 WITH THIS
function waveReport() {
    var reportObj = window.reportObj;
    if (!reportObj) { return; }
    reportObj.html('');
    if (!descriptor.transcript || descriptor.transcript.length === 0) {
        return reportObj.html('<span class="tag-panel-empty">(No transcript loaded)</span>');
    }

    var tab = $('<TABLE>').addClass('reporttable table table-sm table-hover');
    var thead = $('<THEAD>').append('<tr><th style="width: 121px;">Speaker</th><th>Spoken Words</th></tr>');
    tab.append(thead);
    var tbody = $('<TBODY>').prop('id', 'transcript-tbody');

    descriptor.transcript.forEach(function(line, lineIndex) {
        var tr_row = $('<TR>')
            .prop('id', `transcript-row-${line.id}`)
            .attr('data-original-index', lineIndex); 

        var speakerCell = $('<TD>').addClass('speaker-cell');
        var wrapper = $('<div>').addClass('speaker-content-wrapper');
        var dragHandle = $('<i>').addClass('fa fa-grip drag-handle').attr('title', 'Drag to reorder');
        var speakerText = $('<span>').addClass('speaker-name').text(line.speaker);
        wrapper.append(dragHandle, speakerText);
        speakerCell.append(wrapper);

        var dialogueCell = $('<TD>').addClass('dialogue-cell');
        
        var hoverActionsContainer = $('<div>').addClass('row-actions-container');

        var addAfterBtn = $('<i>')
            .addClass('fa fa-plus add-row-after-btn')
            .attr('title', 'Add row after this')
            .data('line-index', lineIndex);

        var deleteBtn = $('<i>')
            .addClass('fa fa-minus delete-row-btn')
            .attr('title', 'Delete this row')
            .data('line-index', lineIndex);

        hoverActionsContainer.append(addAfterBtn, deleteBtn);

        const dialogueContainer = $('<div class="dialogue-text-container"></div>');
        if (line.words && line.words.length > 0 && line.words[0].start != null) {
            line.words.forEach((word) => {
                dialogueContainer.append($('<span>').addClass('transcript-word').attr({ 'data-start': word.start, 'data-end': word.end }).text(word.text + ' '));
            });
        } else {
            dialogueContainer.text(line.dialogue);
        }
        dialogueCell.append(dialogueContainer, hoverActionsContainer);

        tr_row.append(speakerCell, dialogueCell);
        tbody.append(tr_row);
    });

    tab.append(tbody);
    reportObj.append(tab); 

    if ($.fn.sortable) {
        tbody.sortable({
            handle: '.drag-handle', axis: 'y',
            update: function() {
                const transcriptMap = new Map(descriptor.transcript.map(line => [line.id, line]));

        // 2. Get an array of the row IDs in their NEW visual order from the DOM.
        const newOrderIds = $('#transcript-tbody tr').map(function() {
            return this.id.replace('transcript-row-', '');
        }).get();

        // 3. Rebuild the descriptor.transcript array in the correct order using the map.
        descriptor.transcript = newOrderIds.map(id => transcriptMap.get(id));

        // 4. Re-render the table with the correctly and safely sorted data.
        waveReport();
        changed();
            }
        })
        // .disableSelection();
    }
    window.waveReport = waveReport;
}
let activeInlineEditor = null;

function exitInlineEditMode() {
    if (!activeInlineEditor) return;

    const editorState = { ...activeInlineEditor };
    const parentRow = editorState.originalElement.closest('tr');
    const lineIndex = parentRow.data('original-index');
    let needsRerender = false;

    // Restore the UI first
    parentRow.removeClass('is-editing');
    editorState.container.remove();
    editorState.originalElement.show();
    activeInlineEditor = null;

    // ★★★ THIS IS THE NEW, CORRECTED VALIDATION LOGIC ★★★
    // Only run this check if the row was newly created.
    if (editorState.isNew && typeof lineIndex !== 'undefined' && descriptor.transcript[lineIndex]) {
        const lineData = descriptor.transcript[lineIndex];
        
        // Define the conditions for an "empty" row
        const isDialogueEmpty = (lineData.dialogue.trim() === '');
        const isSpeakerUnchanged = (lineData.speaker.trim() === 'Speaker');

        // If BOTH conditions are true, then the row is truly empty and should be deleted.
        if (isDialogueEmpty && isSpeakerUnchanged) {
            descriptor.transcript.splice(lineIndex, 1);
            changed();
            needsRerender = true; // Flag that the table must be redrawn.
        }
    }

    // If a row was deleted, re-render the entire table to reflect the change.
    if (needsRerender) {
        waveReport();
    }
}

/**
 * A unified function to add a new row to the transcript.
 * Final version with correct scrolling and animation callback.
 * @param {number} [insertionIndex] - The index at which to insert the new row. Defaults to the end.
 */
function addNewRow(insertionIndex) {
    if (window.descriptor.blockEdit) return showLockAlert();
    exitInlineEditMode(); // Always close any existing editor first

    const isAppendingToEnd = (typeof insertionIndex !== 'number') || (insertionIndex >= descriptor.transcript.length);
    const newIndex = isAppendingToEnd ? descriptor.transcript.length : insertionIndex;

    const newLine = {
        id: `line-${Date.now()}-${String(Math.random()).slice(2)}`,
        speaker: 'Speaker', dialogue: '',
        start: null, end: null, words: []
    };

    descriptor.transcript.splice(newIndex, 0, newLine);
    waveReport();
    changed();

    requestAnimationFrame(() => {
        // A nested frame is the safest way to ensure the DOM is fully ready
        requestAnimationFrame(() => {
            const $reportPanel = $('#reportpanel');
            if (!$reportPanel.length) return;

            if (isAppendingToEnd) {
                const $newRow = $('#transcript-tbody tr:last-child');
                if ($newRow.length) {
                    $reportPanel.stop().animate({ scrollTop: $reportPanel[0].scrollHeight }, 300, function() {
                        startInlineEdit($newRow.find('.dialogue-text-container'), true);
                    });
                }
            } else {
                const $newRow = $(`#transcript-row-${newLine.id}`);
                if ($newRow.length) {
                    // The final correct scroll calculation
                    const rowTopInContent = $newRow.position().top;
                    const panelHeight = $reportPanel.height();
                    const rowHeight = $newRow.outerHeight();
                    const targetScrollTop = $reportPanel.scrollTop() + rowTopInContent - (panelHeight / 2) + (rowHeight / 2);

                    $reportPanel.stop().animate({ scrollTop: targetScrollTop }, 300, function() {
                        startInlineEdit($newRow.find('.dialogue-text-container'), true);
                    });
                }
            }
        });
    });
}
/**
 * Creates a clean, "border-only" inline editor that replaces the original text.
 * @param {jQuery} $element The text container element that was double-clicked.
 * @param {boolean} [isNewRow=false] - A flag to indicate if this is a newly created, provisional row.
 */
function startInlineEdit($element, isNewRow = false) {
    if (activeInlineEditor) {
        exitInlineEditMode();
    }

    const isSpeaker = $element.hasClass('speaker-name');
    const parentRow = $element.closest('tr');
    const lineIndex = parentRow.data('original-index');
    if (typeof lineIndex === 'undefined' || !descriptor.transcript[lineIndex]) return;

    const originalText = isSpeaker ? descriptor.transcript[lineIndex].speaker : descriptor.transcript[lineIndex].dialogue;
    const $editorContainer = $('<div class="inline-editor-container"></div>');
    let $editor;
    let $actions = null;

    // Use a simple input for the speaker name
    if (isSpeaker) {
        $editor = $('<input type="text" class="inline-editor-input">').val(originalText);
    } else {
        // Use a textarea for the dialogue to allow for multi-line text
        $editor = $('<textarea class="inline-editor-textarea"></textarea').val(originalText);
    }

    // --- THIS IS THE KEY ---
    // Only add the save/cancel buttons for the dialogue area (the right side).
    if (!isSpeaker) {
        $actions = $(`
            <div class="inline-editor-actions">
                <button class="btn-bubble-style btn-save" title="Save (Shift+Enter)"><i class="fa fa-check"></i></button>
                <button class="btn-bubble-style btn-cancel" title="Cancel (Esc)"><i class="fa fa-times"></i></button>
            </div>
        `);
    }

    $editorContainer.append($editor);
    if ($actions) $editorContainer.append($actions);

    $element.hide();
    $element.after($editorContainer);
    parentRow.addClass('is-editing');
    
    // Focus the editor but do not auto-select all text.
    $editor.focus();

    // Auto-resize the textarea if it's used for dialogue
    if (!isSpeaker) {
        const $textarea = $editor;
        function resizeTextarea() {
            $textarea.css('height', 'auto');
            $textarea.css('height', `${$textarea[0].scrollHeight}px`);
        }
        $textarea.on('input', resizeTextarea);
        setTimeout(resizeTextarea, 0); // Resize on creation
    }

    activeInlineEditor = {
        container: $editorContainer,
        originalElement: $element,
        isNew: isNewRow
    };

    function saveChanges() {
        const newText = $editor.val().trim();
        if (newText === '' && !isSpeaker && isNewRow) {
             cancelChanges();
             return;
        }

        if (isSpeaker) {
            descriptor.transcript[lineIndex].speaker = newText;
        } else {
            descriptor.transcript[lineIndex].dialogue = newText;
            descriptor.transcript[lineIndex].words = [];
            descriptor.transcript[lineIndex].start = null;
            descriptor.transcript[lineIndex].end = null;
        }
        changed();
        exitInlineEditMode();
        waveReport();
    }

    function cancelChanges() {
        exitInlineEditMode();
    }

    $editor.on('keydown', function(e) {
        if (isSpeaker) {
            if (e.key === 'Enter') { e.preventDefault(); saveChanges(); }
            if (e.key === 'Escape') { cancelChanges(); }
        } else {
            if (e.key === 'Enter' && e.shiftKey) { e.preventDefault(); saveChanges(); }
            if (e.key === 'Escape') { cancelChanges(); }
        }
    });

    if (isSpeaker) {
        $editor.on('blur', saveChanges);
    }

    if ($actions) {
        $actions.find('.btn-save').on('click', saveChanges);
        $actions.find('.btn-cancel').on('click', cancelChanges);
    }
}

$(document).on('dblclick', '.speaker-cell, .dialogue-cell', function(e) {
    if ($(this).find('.inline-editor-container').length > 0) {
        return;
    }
    
    // Find the correct text element within the clicked cell to edit
    const $targetElement = $(this).find('.speaker-name, .dialogue-text-container');
    if ($targetElement.length) {
        startInlineEdit($targetElement);
    }
});

$(document).on('click', function(e) {
    // If there's no active editor, do nothing.
    if (!activeInlineEditor) return;

    const isClickInsideEditor = $(e.target).closest('.inline-editor-container').length > 0;
    const isClickInsideWavePanel = $(e.target).closest('.wavepanel').length > 0;
    const isClickInsideSeekBar = $(e.target).closest('.player-seek-container').length > 0;

    if (!isClickInsideEditor && !isClickInsideWavePanel && !isClickInsideSeekBar) {
        exitInlineEditMode();
    }
});

$(document).on('click', '#transcript-tbody tr', function() {
    // Remove the class from any previously selected row
    $('#transcript-tbody tr.selected-row').removeClass('selected-row');
    // Add the class to the currently clicked row
    $(this).addClass('selected-row');
});
// Find this near the end of the file
$(document).on('click', '.add-row-after-btn', function(e) {
    e.stopPropagation(); // <-- THIS IS THE CRITICAL FIX
    if (window.descriptor.blockEdit) return showLockAlert();
    const lineIndex = $(this).data('line-index');
    exitInlineEditMode();
    addNewRow(lineIndex + 1);
});
$(document).on('click', '.delete-row-btn', function() {
    const lineIndex = $(this).data('line-index');

    // Confirm before deleting
    myAlert(
        'Confirm Deletion',
        'Are you sure you want to delete this dialogue row?',
        '^Delete Row',
        function() {
            // Remove the line from the data array
            descriptor.transcript.splice(lineIndex, 1);
            // Re-render the table and save changes
            myAlertClose(function() {
                waveReport();
                changed();
            });
        },
        'Cancel',
        // --- THIS IS THE FIX ---
        // Instead of passing myAlertClose directly, we wrap it in a function.
        function() { myAlertClose(); }
    );
});
$('#reportpanel').css('position', 'relative'); // <-- ADD THIS LINE

    var tr = new tracks( $('#videotrackanotate'), $('#video'), null, tagData, $('#reportpanel') );
	setupTranscriptionImport();
    window.trackObj = tr;
    const needsAlignment = checkIfTranscriptNeedsAlignment();

    // 2. If it returns true, show the button and status message.
    if (needsAlignment) {
        console.log("State check: Transcript needs alignment. Showing UI elements.");
        //HOLD Align button for testing
        $('#align-btn').hide();
        // $('#align-status').text('Draft loaded. Click "Align Transcript" to get timestamps.');
    }
    setTimeout(function() {
        if (window.reportObj && typeof waveReport === 'function') {
            waveReport();
        }
    }, 500);

	if( !tagData.attributes ) $('#video-attr').hide();
    if (!tagData.mediaAttributes) tagData.mediaAttributes = {};
    listAttributes( $('#video-attr'), tagData.attributes, tagData.mediaAttributes, 'Media Attributes' );
    $('crowd-form').on('submit',function() {
        var annotations = exportData();
        if( document.location.href.indexOf('localhost') >= 0 && annotations ) saveClipboard( JSON.stringify(annotations.streams || {}) )
        if( annotations )
        {
            $('crowd-form').show();
            document.getElementById('annotations').value = JSON.stringify(annotations);
        }
        else
        return false;
    });

   	var form = document.querySelector('crowd-form');
    setButtons(descriptor);
    showSave('Session started', descriptor.sessionStart*1000 )

    $('#submitButton').on('click', function () {
        declined = false;
        if (form) form.submit();
        else submitAnnotations();
    });
$('<style>')
.text(`
    /* General Table Styles */
    .reporttable { width: 100% !important; border-collapse: separate !important; border-spacing: 0 8px !important; margin-top: -8px; table-layout: fixed; }
    .reporttable td {
        background-color: #ffffffff; padding: 20px !important; border: none !important;
        vertical-align: top !important; 
        position: relative;
        border-radius: 6px;
        word-break: break-word;
    }
    .speaker-content-wrapper {
        display: flex;
        align-items: flex-start; /* Aligns the drag handle and speaker name to the top */
        gap: 8px; /* Adds some space between the icon and the text */
    }
    tr.is-editing .dialogue-cell {
        overflow: visible; 
    }
    
    .speaker-name, .dialogue-text-container {
        cursor: pointer; display: block;
        width: 100%; min-height: 20px;
        padding: 8px 12px; margin: -8px -12px;
        border: 2px solid transparent; border-radius: 8px;
        white-space: normal;
        word-wrap: break-word;
    }
    
    /* Top Control Button Styles */
    .transcript-controls-container {
        display: flex; gap: 25px;
        padding: 10px 0; align-items: center;
    }
    .action-btn {
        background: none; border: none; cursor: pointer; color: #5e5873;
        font-size: 0.9rem; font-weight: 500; display: flex;
        align-items: center; gap: 8px;
        transition: color 0.2s ease;
    }
    .action-btn:hover { color: #7367f0; }
    .action-btn i { font-size: 1.1rem; }

    /* Vertical Y-Axis Icons */
    .row-actions-container {
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        transition: opacity 0.2s ease;
        display: flex;
        flex-direction: column; 
        align-items: center; 
        gap: 4px; 
    }
    tr:hover .row-actions-container {
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
    }
    .add-row-after-btn, .delete-row-btn {
        position: unset !important;
        display: flex; 
        align-items: center;
        justify-content: center;
        width: 20px; 
        height: 10px;
        background: none !important;
        border: none !important;
        box-shadow: none !important;
        border-radius: 2px;
        font-size: 1.2rem;
        font-weight: bold;
        cursor: pointer;
        padding: 0;
        line-height: 1;
        margin: 0; 
    }
    .add-row-after-btn {
        color: #28a745 !important;
    }
    .delete-row-btn {
        color: #dc3545 !important;
    }
    .add-row-after-btn:hover, .delete-row-btn:hover {
        opacity: 0.7;
    }
    
    tr.is-editing .row-actions-container { display: none !important; }

    /* ★★★ START OF INLINE EDITOR FIXES ★★★ */
    .inline-editor-container {
        position: relative;
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .inline-editor-textarea, .inline-editor-input {
        display: block; width: 100%; box-sizing: border-box; cursor: text;
        flex-grow: 1; /* <-- Makes text box fill available space */
        background-color: #fff !important;
        border: 2px solid #7367f0 !important;
        border-radius: 8px; padding: 8px 12px; /* Margin removed */
        box-shadow: 0 2px 8px rgba(115,103,240,0.2) !important;
        outline: none !important; resize: none !important;
        font-family: inherit !important; font-size: inherit !important;
        line-height: inherit !important; color: inherit !important;
    }
    .inline-editor-actions {
        display: flex; 
        flex-direction: column;
        gap: 6px; 
    }
    /* ★★★ END OF INLINE EDITOR FIXES ★★★ */

    .btn-bubble-style {
        display: inline-flex; align-items: center; justify-content: center;
        width: 24px; height: 24px; border-radius: 50% !important;
        border: 1px solid #b0b0b0 !important; background-color: #fff !important;
        color: #555 !important; font-size: 0.8rem !important;
        box-shadow: 0 2px 5px rgba(0,0,0,0.2); cursor: pointer;
    }
    .btn-bubble-style:hover { background-color: #f0f0f0 !important; }
`)
.appendTo('head');

}

// function setupTranscriptionImport() {
//     // 1. Create the UI elements
//     const importButton = $('<button class="btn btn-secondary btn-sm mb-2" id="import-draft-btn">Import Draft File</button>');
//     const fileInput = $('<input type="file" accept=".txt,.json" style="display: none;" id="draft-file-input">');
    
//     // The Align button is now simpler. It doesn't need its own file input.
//     const alignButton = $('<button class="btn btn-primary btn-sm mb-2 ml-2" id="align-btn" style="display:none;">Align Transcript</button>');
//     const statusDiv = $('<div id="align-status" class="mb-2" style="font-style: italic; color: #6c757d;"></div>');

//     // Add elements to the report panel
//     $('#reportpanel').before(importButton, alignButton, fileInput, statusDiv);

//     // 2. Wire up the buttons
//     importButton.on('click', function() {
//         fileInput.click();
//     });

//     fileInput.on('change', function(event) {
//         const file = event.target.files[0];
//         if (!file) return;

//         const reader = new FileReader();
//         reader.onload = function(e) {
//             const content = e.target.result;
//             parseTranscription(content);
//             waveReport();
//             changed();
//             fileInput.val('');
//             alignButton.show(); // Show the Align button after import
//             statusDiv.text('Draft loaded. Click "Align Transcript" to get timestamps.');
//         };
//         reader.readAsText(file);
//     });

//     // 3. The Align button now directly triggers the alignment process
//     alignButton.on('click',  function() {
//          handleAlignment();
//     });
// }


// REPLACE the existing parseTranscription function with this
function parseTranscription(textContent) {
    const lines = textContent.split('\n').filter(line => line.trim() !== '');
    const speakerMap = {
        'speaker1': 'Customer',
        'speaker2': 'Representative'
    };

    descriptor.transcript = lines.map((line, index) => {
        const match = line.match(/^(speaker\d+):\s*(.*)/);
        if (match) {
            return {
                id: `line-${index}`,
                speaker: speakerMap[match[1]] || match[1],
                dialogue: match[2].trim(),
                start: null,
                end: null,
                words: [] // Prepare array to hold timed words
            };
        }
        return {
            id: `line-${index}`,
            speaker: 'Unknown',
            dialogue: line.trim(),
            start: null,
            end: null,
            words: [] // Prepare array to hold timed words
        };
    }).filter(item => item.dialogue);
    
    console.log("Parsed Transcription Data into descriptor.transcript");
}
function exists( o )
{
	if( !o ) return false;
	if( !isobj(o) && !isarray(o)) return false;
	return Object.keys(o).length > 0;
}


function showHide( o, cond )
{
	if( cond ) o.show();
	else o.hide();
}

var chatNotificationRead = false;
function displayNotes() {
    // return;
	$('#messages').remove();
	if (descriptor.reviewMode) {
		$('#reviewer_notes').hide();
		$('#submitReviewer').show();
	}
	else {
		// $('#messages').hide();
		$('#annotator_notes').hide();
		$('#submitReviewer').hide();
	}
	$('#chatbox').removeClass('unselectable').css({position:'relative'});
	$('#chat_notification').hide();
	$('#chatbox').off('click').on('click', chatPopup );
	if( !chatNotificationRead )
		if( $('#reviewer_notes').val().trim() || $('#annotator_notes').val().trim() || (descriptor.messages && descriptor.messages.length)) $('#chat_notification').css({marginTop:3}).show();
;
}

function chatPopup() {
	let content = '<div id="messages" class="file-messages"></div>';
		if( descriptor.reviewMode ) {
			content += '<textarea id="chat_reviewer_notes" class="inote-text mt-2" placeholder="Reviewer Notes"></textarea>';
		}
		else {
			content += '<textarea id="chat_annotator_notes" class="inote-text mt-2" placeholder="Annotator Notes"></textarea>';
		}
		frm.myAlert( 'Messages', content, 'Ok' );
		displayMessages();
	if( blockEdit ) {
		$('.modal-body').find('textarea').attr('disabled', true);
	}
	setTimeout( function(){
		$('.modal-body').scrollTop( 100000 )
		if( !blockEdit ) {
			if( descriptor.reviewMode ) {
				$('#chat_reviewer_notes')[0].focus();
			}
			else {
				$('#chat_annotator_notes')[0].focus();
			}
		}
        else {
            $('#chat_annotator_notes').val('')
        } 
	}, 500 )

	// copy notes to original text area for compatibility
	$('#chat_reviewer_notes').on('change', function(){
		$('#reviewer_notes').val($(this).val());
		changed();
	} ).val($('#reviewer_notes').val())
	$('#chat_annotator_notes').on('change', function(){
		$('#annotator_notes').val($(this).val());
		descriptor.mediaAttributes["Aditional Notes"] = $(this).val(); 
		changed()
	} ).val($('#annotator_notes').val())
    if( blockEdit ) $('#chat_annotator_notes').val('')


	chatNotificationRead = true;
	$('#chat_notification').hide();
}


function displayMessages()
{
	if( !descriptor.messages ) return;
	$('#messages').show().html('');
	var role = ['Annotator','QC'];

	var showMoreLess = $('<DIV>').addClass('message-show');
	$('#messages').append(showMoreLess);
	var nshow = 2;
	var nmess = descriptor.messages.length;
	function showMore()
	{

	}
	function show()
	{
		var hidden = 0;
		for( var i = 0 ; i < nmess-nshow ; i++ )
		{
			$('.message-idx-'+i).hide();
			hidden++;
		}
		for( ; i < nmess ; i++ )
			$('.message-idx-'+i).show();
		if( hidden )
		{
			showMoreLess.text('Show more messages').off('click').on('click', function(){
				nshow += 3;
				show();
			});
		}
		else if( nmess > 2 )
		{
			showMoreLess.text('Show less messages').off('click').on('click', function(){
				nshow = 1;
				show();
			});
		}
	}
	
	descriptor.messages.forEach((m,idx)=>{
		var m = $('<DIV>').addClass('message-'+m[0]).addClass('message-idx-'+idx).html('<i>'+role[m[0]]+'</i><br>' + m[1]);
		$('#messages').append(m);
	});
	// show();
}


function displayMessagesOld()
{
	$('#messages').show().html('');
	var role = ['Annotator','QC'];

	var showMoreLess = $('<DIV>').addClass('message-show');
	$('#messages').append(showMoreLess);
	var nshow = 2;
	var nmess = descriptor.messages.length;
	function showMore()
	{

	}
	function show()
	{
		var hidden = 0;
		for( var i = 0 ; i < nmess-nshow ; i++ )
		{
			$('.message-idx-'+i).hide();
			hidden++;
		}
		for( ; i < nmess ; i++ )
			$('.message-idx-'+i).show();
		if( hidden )
		{
			showMoreLess.text('Show more messages').unbind('click').on('click', function(){
				nshow += 3;
				show();
			});
		}
		else if( nmess > 2 )
		{
			showMoreLess.text('Show less messages').unbind('click').on('click', function(){
				nshow = 1;
				show();
			});
		}
	}

	descriptor.messages.forEach((m,idx)=>{
		var m = $('<DIV>').addClass('message-'+m[0]).addClass('message-idx-'+idx).html('<i>'+role[m[0]]+'</i><br>' + m[1]);
		$('#messages').append(m);
	});
	show();
}


var questionMode = false;
var currentQuestion = 0;

function start(desc) {
    console.log("RAW DESCRIPTOR FROM SERVER:", JSON.parse(JSON.stringify(desc)));
    descriptor = tagData = desc;
    window.descriptor = descriptor;
	reviewMode = descriptor.reviewMode ? true : false;

    // Ensure report panel element exists and is visible
    if (!$('#reportpanel').length) {
        console.error("Report panel element #reportpanel not found in DOM!");
    } else {
        console.log("Report panel element found, ensuring it's visible...");
        $('#reportpanel').show();
    }

    if( mode == 'template' ) $('#resumeLater').hide();
    $('#reviewer-fields').hide();
    $('#annotator_notes').show();
	if( descriptor.reviewMode )
	{
		$('#reviewer-fields').show();
		$('#annotator_notes').hide();
		if( !descriptor.reviewMayRequestAdjustment ) $('#optadjust').remove();
	}
	if( !exists( descriptor.messages) ) $('#messages').hide();
	else displayMessages();
	$('#reviewer_rate').on('change', changed );
	$('#reviewer_notes').on('change', changed );
	$('#annotator_notes').on('change', changed );
	var now = getsec();
	if( !descriptor.elapsedTime )
	{
		descriptor.elapsedTime = 0;
		if( !descriptor.jobStart ) descriptor.jobStart = now;
	}
    else if( !descriptor.tsSeconds ) descriptor.elapsedTime /= 1000;
	descriptor.sessionStart = now;

    if( mode != 'template' )
    {
        $(document.body).css({overflow:'hidden'});
    }

    if (!descriptor.questionnaire || !descriptor.questionnaire.length) init();
    else {
        questionMode = true;
        function submitQuestions() {
            var annotations = { videoData: descriptor.videoData, annotations: clone(descriptor.questionnaireAnnotations) };
            if (document.location.href.indexOf('localhost') >= 0) saveClipboard(JSON.stringify(annotations.annotations))
            if (annotations) {
                document.getElementById('annotations').value = JSON.stringify(annotations);
                $('crowd-form').show();
                $('crowd-form')[0].onsubmit = null;
                $('crowd-form')[0].submit();
            }
            else
                return false;
        }

        function question(q) {
            function save(callback) {
                // if( 0 && !questionData.answer )
                // {
                // 	modal( 'Answer Required', 'Please answer the question' );
                // 	return false;
                // }
                questionData.streams = tr.saveTracks();
                var nev = 0;
                questionData.streams.forEach(e => {
                    nev += e.ranges.length;
                });
                if (questionData.false && !questionData.userAnswer) {
                    return modal('Answer Required', 'Please write the correct answer for the question.', 'Ok', function () {
                        modalWait(function () {
                            $('#questionUserAnswer').focus();
                        })
                    })
                }
                if (!nev) {
                    if (questionData.streams.length) return modal('Record Evidence Position', "You must record the evidence position in the video.")
                    modal('Evidence Required', 'Please annotate evidences about your answer.');
                    return;
                }
                console.log('streams', questionData.streams);
                if (!questionData.false) delete questionData.userAnswer;
                descriptor.questionnaireAnnotations[q] = questionData;
                // if( nev && !questionData.false )
                // {
                // 	return modal( 'Discard Evidence', 'You selected the answer as <b>True</b>. Discard current annotated evidences?', 'Discard Evidences', function(){
                // 		modalWait( function(){
                // 			questionData.streams = [];
                // 			callback();
                // 		} );
                // 	} );
                // }
                $('#questionUserAnswer').unbind('change')
                callback();
                return true;
            }
            $('#prevnextBox').show();
            // if( q == descriptor.questionnaire.length ) return submitQuestions();
            var qlab = descriptor.questionnaire[q].question;
            currentQuestion = q;

            if (!descriptor.questionnaireAnnotations) descriptor.questionnaireAnnotations = {};
            if (!descriptor.questionnaireSettings) descriptor.questionnaireSettings = {};
            if (!descriptor.questionnaireAnnotations[currentQuestion]) descriptor.questionnaireAnnotations[currentQuestion] = {};
            $('#questionTitle').html('Q.: ' + descriptor.questionnaire[currentQuestion].question);
            $('#questionInstructions').html(descriptor.questionnaireInstructions || '');
            $('crowd-form').hide();
            $('#videotrackanotate').html('');
            $('#reportpanel').html('');
            var tr = new tracks($('#videotrackanotate'), $('#video'), null, tagData, $('#reportpanel'));

            // Ensure report panel is populated for questionnaire mode
            setTimeout(function() {
                if (window.ensureReportPanel) {
                    window.ensureReportPanel();
                }
            }, 300);

            var questionData = descriptor.questionnaireAnnotations[currentQuestion];
            questionData.question = qlab;
            questionData.answer = descriptor.questionnaire[currentQuestion].answer
            // questionData.userAnswer = descriptor.questionnaire[currentQuestion].userAnswer
            // $('#questionAnswer').val(questionData.answer).unbind('change').on('change',function(){ questionData.answer = $(this).val().trim()});
            $('#questionAnswer').html('A.: ' + questionData.answer);
            showHide($('#questionUserAnswer'), questionData.false);
            checkBox($('#questionFalse'), 'False', questionData.false, function (v) {
                questionData.false = v;
                showHide($('#questionUserAnswer'), v);
            });
            $('#questionUserAnswer').val(questionData.userAnswer).unbind('change').on('change', function () {
                questionData.userAnswer = $(this).val();
                console.error('userAnswer', questionData.userAnswer)
            })

            setTimeout(function () {
                console.log('questionData', questionData)
                tr.loadTracks(questionData.streams);
            }, 100);

            if (!tagData.attributes) $('#video-attr').hide();
            if (!tagData.mediaAttributes) tagData.mediaAttributes = {};
            listAttributes($('#video-attr'), tagData.attributes, tagData.mediaAttributes, 'Media Attributes' )
            // function submitAnnotations(ev) {
            //     save(function () {
            //         submitQuestions
            listAttributes($('#video-attr'), tagData.attributes, tagData.mediaAttributes, 'Media Attributes' )
            // function submitAnnotations(ev) {
            //     save(function () {
            //         submitQuestions()
            //     });
            // };
            // if (q < descriptor.questionnaire.length - 1) $('#submitBox').hide();
            // else $('#submitBox').show();
            $('.trackaddbutton').html(descriptor.questionnaire[currentQuestion].button);
            $('.prevnext_number').html('<span>' + (q + 1) + ' of ' + descriptor.questionnaire.length + '</span>')
            $('#buttonPrev').prop('disabled', q == 0).unbind('click').on('click', function () {
                save(function () {
                    question(currentQuestion - 1)
                })
            });
            $('#buttonNext').prop('disabled', q == descriptor.questionnaire.length - 1).unbind('click').on('click', function () {
                save(function () {
                    question(currentQuestion + 1)
                })
            });
            $('#submitButton').off('click').on('click', submitAnnotations);
        }
        $('#video-attr').hide();
        question(0);
    }
}

// EXPORTEND
var declined = false;
var claimed = false;
var released = false;
var blockEdit = false;

function fixButtons(descriptor) {
	if( !descriptor ) return;
	$('.task-button').hide();
    $('.mode-select').hide();
	$('.claim-button').html('Claim Task as '+descriptor.task_role)
    $('#reviewer_rate_div').hide()
    if( descriptor.task_role ) 
	if( descriptor.blockEdit ) {
		if( descriptor.task_can_claim ) {
			if( descriptor.task_auto_claim ) {
               
				setTimeout( function(){
                 
					$('.claim-button')[0].click();
				}, 1 );
			}
			else {
				$('.claim-button').show();
			}
		}
		$('#resumeLater').hide();
	}
	else {
        if( descriptor.task_role == 'Reviewer') {
              
            $('#reviewer_rate_div').show()
        }
		$('#resumeLater').show();
		$('.claim-button').hide();
		$('.submit-button').show();
		$('.autolabel-button').show();
		if( descriptor.task_can_decline ) $('.decline-button').show();
		if( descriptor.task_can_release ) {
			$('.release-button').show();
		}
	}
	reviewMode = descriptor.reviewMode;
	if( descriptor.reviewMode )
	{
		$('#reviewer-fields').show();
		$('#annotator_notes').hide();
		if( !descriptor.reviewMayRequestAdjustment ) $('#optadjust').remove();
	}
	blockEdit = descriptor.blockEdit;
	displayNotes();
    if ($('.player-seek-bar').length) {
        $('.player-seek-bar').toggleClass('task-locked', descriptor.blockEdit);
    }
	// ckSelectDisable();
	// $('#right').find('select').attr('disabled', blockEdit)

}


function setButtons(descriptor,form) {
	$('#submitButton').removeClass('mt-2').addClass('mr-2').addClass('submit-button').addClass('task-button');
	var claimBtn = $('<button type="submit" class="btn btn-primary btn-primary mr-2 task-button claim-button">').html('Claim Task');
	$('#submitButton').before(claimBtn);
	claimBtn.on('click', function () {
		claimTask(descriptor);
	});
	var declineBtn = $('<button type="submit" class="btn  btn-danger mr-2 task-button decline-button">').html('<i class=" mr-2 fa fa-ban" aria-hidden="true"></i>Decline  ').hide();//modify Decline Task  as  Decline - mani
	$('#submitButton').after(declineBtn);
	declineBtn.on('click', function () {
		declined = claimed = released = false;
		declined = true;
		if (form) form.submit();
		else submitAnnotations();
	});
	var releaseBtn = $('<button type="submit" class="btn btn-primary btn-warning mr-2 task-button release-button">').html('<i class=" mr-2 fa fa-unlock" aria-hidden="true"></i>Release');  //modify Release Task  as Remove - mani
	declineBtn.after(releaseBtn);
	releaseBtn.on('click', function () {
		releaseTask(descriptor);
	});
	descriptor.fixButtons = fixButtons;
	fixButtons(descriptor);
}


var claimTask = function(d) {
	descriptor.claimCallback(d);
}

var releaseTask = function(d) {
	descriptor.releaseCallback(d);
}


var submitAnnotations = async function() {
    var annotations = exportData();
    
    if (annotations) {
        let isDecline = declined && declineReason;
        if (!isDecline && !await frm.myConfirm('Confirm Submit', "Do you really want to submit your annotations?", null, "Yes, submit annotations", "No")) 
            return;

        // --- FIX STARTS HERE ---
        // If in review mode, ensure the review object is properly created and populated.
        if (descriptor.reviewMode) {
            // If the exportData function didn't create the review object, create it now.
            if (!annotations.review) {
                annotations.review = {};
            }
            // Always assign the reviewer ID.
            annotations.review.reviewerId = window.GlobalVars.userId || window.GlobalVars.userWorkerId;

            // Also ensure the rate and note are included, even if they are empty.
            // This prevents errors if they weren't set by exportData.
            if (typeof annotations.review.rate === 'undefined') {
                annotations.review.rate = $('#reviewer_rate').val() || '';
            }
            if (typeof annotations.review.note === 'undefined') {
                annotations.review.note = $('#reviewer_notes').val().trim() || '';
            }
        }
        // --- FIX ENDS HERE ---

        clearTimeout(changeTid);
        descriptor.submit(annotations);
    } else {
        return false;
    }
};

var updateFlag = false;
function updating(){
	return updateFlag;
}

function showSave(s, ts)
{
	// descriptor.version = s;
	if( ts ) s += ' - ' + new Date(ts).toLocaleString()
	$('#version').remove();
    $('#submit').hide();
	$('#t_right').prepend(
		$('<span>')
		.addClass('version')
		.prop('id','version')
		.html(s)
	);
}


var changeTid = null;
changed = function() {
    if (descriptor.blockEdit) return;
    console.log('changed');
    clearTimeout(changeTid);
    updateFlag = true;
    window.onbeforeunload = function(ev) {
        ev.preventDefault();
        return ev.returnValue = "Are you sure you want to exit?";
    };
    
    changeTid = setTimeout(function() {
        var annotations = exportData(1);
        if (!annotations) {
            console.error("Auto-save failed: exportData returned null.");
            return;
        }

        descriptor.update(annotations, res => {
            window.onbeforeunload = null;
            updateFlag = false;
            showSave('Saved', Date.now());
            // ADD THIS LINE FOR VERIFICATION
            console.log('Data sent to server for auto-save:', annotations); 
        });
    }, 500);
};

function checkInstructions(descriptor) {
    if(descriptor.blockEdit) return;

    const engine = new Liquid();

    // --- THIS IS THE FIX ---
    // This line now checks for metadata inside descriptor.media before falling back.
    const data = (descriptor.pdf && descriptor.pdf.metadata) || (descriptor.media && descriptor.media.metadata) || descriptor.metadata;

    // Render a template using Liquid
    let itext = (descriptor.globalTaskInstructions && descriptor.globalTaskInstructions.text) || '';
    if( itext && data ) { // Added a check for 'data' to prevent errors
        engine
            .parseAndRender(itext.replace(/\n/g, '<br>'), data)
            .then(result => {
                if (descriptor.globalTaskInstructions.showModal && descriptor.globalTaskInstructions.text) {
                    frm.myAlert('Instructions', result, 'Ok');
                }
    
                if(descriptor.globalTaskInstructions.text){
                    if($('#right').find('.instruct').length > 0){
                        $('#right').find('.instruct').remove();
                    }
    
                    let instructionsBox = `
                    <div class="instruct">
                        <div class="panel-title">Instructions</div>
                        <p>${result || 'No Instrctions set'}</p>
                    </div>`
                    
                    $('#right').prepend(instructionsBox)
                }
            })
            .catch(error => {
                console.error('Error rendering template:', error);
            });
    }
}
checkInstructions(descriptor);

myAlert = frm.myAlert;
myAlertClose = frm.myAlertClose;

// Function to ensure report panel is populated
function ensureReportPanel() {
    if (window.reportObj && typeof waveReport === 'function') {
        console.log("Manually ensuring report panel is populated...");
        
        // Make sure the report panel is visible
        if (window.reportObj.length && window.reportObj.is(':hidden')) {
            console.log("Report panel was hidden, making it visible...");
            window.reportObj.show();
        }
        
        // eslint-disable-next-line no-undef
        waveReport();
    } else {
        console.warn("Cannot populate report panel - reportObj or waveReport not available");
    }
}

// Make this function globally available
window.ensureReportPanel = ensureReportPanel;

// Add keyboard event listener for delete key functionality

// Function to remove table row corresponding to a deleted region
function removeTableRowForRegion(regionId) {
    try {
        // Look for table rows that might correspond to this region
        // Check multiple possible selectors for the table rows
        const possibleSelectors = [
            `tr[data-region-id="${regionId}"]`,
            `tr[data-id="${regionId}"]`,
            `tr[id="wavereport${regionId}"]`, // UPDATED: More specific selector
            `tr[data-wave-id="${regionId}"]`,
            `.annotation-row[data-region-id="${regionId}"]`,
            `.table-row[data-region-id="${regionId}"]`
        ];
        
        let rowFound = false;
        
        // Try each selector to find the corresponding row
        for (let selector of possibleSelectors) {
            const $row = $(selector);
            if ($row.length > 0) {
                console.log(`Found table row with selector: ${selector}`);
                $row.remove();
                rowFound = true;
                break;
            }
        }
        
        if (!rowFound) {
            console.warn(`Could not find table row for deleted region: ${regionId}`);
        } else {
            console.log(`Successfully removed table row for region: ${regionId}`);
        }
        
    } catch (error) {
        console.error("Error removing table row for region:", regionId, error);
    }
}

// Function to setup WaveSurfer region selection tracking
function setupRegionSelectionTracking() {
    if (window.wavesurfer && window.wavesurfer.regions) {
        // Listen for region click events to track selection
        window.wavesurfer.on('region-click', function(region, e) {
            // Clear previous selections
            for (let regionId in window.wavesurfer.regions.list) {
                const r = window.wavesurfer.regions.list[regionId];
                if (r.element) {
                    r.element.classList.remove('wavesurfer-region-selected');
                }
                r.selected = false;
            }
            
            // Mark the clicked region as selected
            if (region.element) {
                region.element.classList.add('wavesurfer-region-selected');
            }
            region.selected = true;
            window.selectedRegionId = region.id;
            
            // Also highlight the corresponding table row
            highlightTableRowForRegion(region.id);
            
            console.log("Region selected:", region.id);
        });
        
        // Listen for clicks outside regions to clear selection
        window.wavesurfer.on('click', function(e) {
            // Check if click was not on a region
            if (!e.target.closest('.wavesurfer-region')) {
                // Clear all selections
                for (let regionId in window.wavesurfer.regions.list) {
                    const r = window.wavesurfer.regions.list[regionId];
                    if (r.element) {
                        r.element.classList.remove('wavesurfer-region-selected');
                    }
                    r.selected = false;
                }
                window.selectedRegionId = null;
                
                // Clear table row highlighting
                clearTableRowHighlighting();
                
                console.log("All regions deselected");
            }
        });
        
        // Listen for table row clicks to select corresponding regions
        $(document).on('click', 'tr[data-region-id], tr[id^="wavereport"], .annotation-row, .table-row', function(e) {
            const $row = $(this);
            const rowId = $row.attr('id');
            const regionId = rowId ? rowId.replace('wavereport', '') : ($row.data('region-id') || $row.data('id'));
            
            if (regionId && window.wavesurfer.regions.list[regionId]) {
                // Clear previous selections
                for (let rId in window.wavesurfer.regions.list) {
                    const r = window.wavesurfer.regions.list[rId];
                    if (r.element) {
                        r.element.classList.remove('wavesurfer-region-selected');
                    }
                    r.selected = false;
                }
                
                // Select the corresponding region
                const region = window.wavesurfer.regions.list[regionId];
                if (region.element) {
                    region.element.classList.add('wavesurfer-region-selected');
                }
                region.selected = true;
                window.selectedRegionId = regionId;
                
                // Highlight this table row
                clearTableRowHighlighting();
                $row.addClass('selected-table-row');
                
                console.log("Region selected from table row:", regionId);
            }
        });
    }
}

// Function to highlight table row corresponding to selected region
function highlightTableRowForRegion(regionId) {
    try {
        // Clear previous highlighting
        clearTableRowHighlighting();
        
        const $row = $(`#wavereport${regionId}`);
        if ($row.length > 0) {
            $row.addClass('selected-table-row');
            console.log(`Highlighted table row for region: ${regionId}`);
        } else {
             console.log(`No table row found to highlight for region: ${regionId}`);
        }
    } catch (error) {
        console.error("Error highlighting table row for region:", regionId, error);
    }
}

// Function to clear table row highlighting
function clearTableRowHighlighting() {
    $('.selected-table-row').removeClass('selected-table-row');
}

// Initialize keyboard event listeners when the module loads
$(document).ready(function() {
    // setupKeyboardEventListeners();
    
    // Setup region selection tracking when WaveSurfer is ready
    if (window.wavesurfer) {
        setupRegionSelectionTracking();
    } else {
        // Wait for WaveSurfer to be initialized
        const checkWaveSurfer = setInterval(function() {
            if (window.wavesurfer) {
                setupRegionSelectionTracking();
                clearInterval(checkWaveSurfer);
            }
        }, 100);
    }


});

export default {start,updating}